"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AkitaBox Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.UpdateCustomerAccountOrchestrationRequestActionEnum = exports.ThemeActionEnum = exports.StepStatus = exports.ReportsUpdateRequestContentMarginsUnitEnum = exports.ReportTemplatesCreateRequestContextEnum = exports.ReportTemplateResponseContextEnum = exports.ReportTemplateActionEnum = exports.ReportResponseContentMarginsUnitEnum = exports.ReportHeadersAndFootersCreateRequestTypeEnum = exports.ReportHeaderFooterResponseTypeEnum = exports.ReportBlockResponseContextEnum = exports.ProcoreEntityTypeEnum = exports.PinFieldDataType = exports.OrganizationsUpdateRequestActionEnum = exports.OrganizationResponseExportLinkTypeEnum = exports.OrganizationActionEnum = exports.OrchestrationUpdateAction = exports.OrchestrationTargetEntity = exports.OrchestrationStatus = exports.FileActionEnum = exports.CostLineResponseCategoryEnum = exports.CostDataCatalog = exports.AttachmentLinkEnum = exports.AttachmentActionEnum = exports.AssetsUpdateRequestConditionRatingEnum = exports.AssetsUpdateRequestActionEnum = exports.AdminSAMLConfigUpdateRequestActionEnum = exports.AdminIdentitiesUpdateRequestActionEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AdminIdentitiesUpdateRequestActionEnum = {
    Activate: 'activate',
    Deactivate: 'deactivate'
};
exports.AdminSAMLConfigUpdateRequestActionEnum = {
    Update: 'update',
    Activate: 'activate',
    Deactivate: 'deactivate'
};
exports.AssetsUpdateRequestActionEnum = {
    Update: 'update',
    UpdateLevel: 'updateLevel',
    UpdateRoom: 'updateRoom',
    UpdateCondition: 'updateCondition',
    UpdateValues: 'updateValues'
};
exports.AssetsUpdateRequestConditionRatingEnum = {
    VeryGood: 'VERY_GOOD',
    Good: 'GOOD',
    Fair: 'FAIR',
    Poor: 'POOR',
    VeryPoor: 'VERY_POOR',
    Failed: 'FAILED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AttachmentActionEnum = {
    RemoveLink: 'removeLink'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AttachmentLinkEnum = {
    Assembly: 'assembly',
    Asset: 'asset',
    Checklist: 'checklist',
    Condition: 'condition',
    ConditionAssessment: 'condition_assessment',
    Job: 'job',
    Level: 'level',
    Markup: 'markup',
    Room: 'room',
    Request: 'request',
    Step: 'step',
    Task: 'task',
    Report: 'report'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CostDataCatalog = {
    Cnc: 'cnc',
    Fcr: 'fcr',
    Fpm: 'fpm',
    Fmr: 'fmr'
};
exports.CostLineResponseCategoryEnum = {
    Replacement: 'replacement',
    Maintenance: 'maintenance'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FileActionEnum = {
    CompleteUpload: 'completeUpload'
};
/**
 * Status of the orchestration
 * @export
 * @enum {string}
 */
exports.OrchestrationStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Canceled: 'canceled',
    Completed: 'completed',
    Errored: 'errored'
};
/**
 * Entity type that the orchestration targets
 * @export
 * @enum {string}
 */
exports.OrchestrationTargetEntity = {
    Environment: 'environment',
    CustomerAccount: 'customer_account',
    Organization: 'organization'
};
/**
 * Actions that can be performed on an orchestration
 * @export
 * @enum {string}
 */
exports.OrchestrationUpdateAction = {
    StartProcessing: 'start_processing',
    Cancel: 'cancel'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OrganizationActionEnum = {
    OrgAdminUpdate: 'orgAdminUpdate',
    UpdateSubdomain: 'updateSubdomain',
    UpdateRsMeansRelease: 'updateRsMeansRelease',
    Activate: 'activate',
    Deactivate: 'deactivate'
};
exports.OrganizationResponseExportLinkTypeEnum = {
    LongPurl: 'long_purl',
    MediaViewerInline: 'media_viewer_inline'
};
exports.OrganizationsUpdateRequestActionEnum = {
    Activate: 'activate',
    Deactivate: 'deactivate',
    Update: 'update'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PinFieldDataType = {
    Boolean: 'boolean',
    Date: 'date',
    DocumentArray: 'document_array',
    Enum: 'enum',
    Float: 'float',
    Int: 'int',
    Level: 'level',
    Paragraph: 'paragraph',
    Room: 'room',
    String: 'string',
    Url: 'url',
    TagFilter: 'tag_filter'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProcoreEntityTypeEnum = {
    Image: 'image',
    ProjectFile: 'projectFile',
    DrawingRevision: 'drawingRevision',
    Submittal: 'submittal'
};
exports.ReportBlockResponseContextEnum = {
    Asset: 'asset',
    Building: 'building'
};
exports.ReportHeaderFooterResponseTypeEnum = {
    Header: 'header',
    Footer: 'footer'
};
exports.ReportHeadersAndFootersCreateRequestTypeEnum = {
    Header: 'header',
    Footer: 'footer'
};
exports.ReportResponseContentMarginsUnitEnum = {
    In: 'in',
    Cm: 'cm',
    Mm: 'mm'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportTemplateActionEnum = {
    Update: 'update'
};
exports.ReportTemplateResponseContextEnum = {
    Organization: 'organization',
    Building: 'building'
};
exports.ReportTemplatesCreateRequestContextEnum = {
    Organization: 'organization',
    Building: 'building'
};
exports.ReportsUpdateRequestContentMarginsUnitEnum = {
    In: 'in',
    Cm: 'cm',
    Mm: 'mm'
};
/**
 * Status of the step
 * @export
 * @enum {string}
 */
exports.StepStatus = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed',
    Skipped: 'skipped'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ThemeActionEnum = {
    Update: 'update',
    Activate: 'activate',
    Deactivate: 'deactivate'
};
exports.UpdateCustomerAccountOrchestrationRequestActionEnum = {
    StartProcessing: 'start_processing',
    Cancel: 'cancel'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Creates an account
         * @param {AccountCreateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreate: (customerAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccount' is not null or undefined
            (0, common_1.assertParamExists)('accountCreate', 'customerAccount', customerAccount);
            const localVarPath = `/admin/customer_accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerAccount, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of customer accounts
         * @param {string} [name]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsCount: (name, canCreateOrganizations, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/customer_accounts?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (canCreateOrganizations !== undefined) {
                localVarQueryParameter['can_create_organizations'] = canCreateOrganizations;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of customer accounts
         * @param {string} [sort]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [modifyIdentities]
         * @param {string} [id]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGet: (sort, name, limit, skip, modifyIdentities, id, canCreateOrganizations, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/customer_accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (modifyIdentities !== undefined) {
                localVarQueryParameter['modify_identities'] = modifyIdentities;
            }
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (canCreateOrganizations !== undefined) {
                localVarQueryParameter['can_create_organizations'] = canCreateOrganizations;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGetById: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('adminCustomerAccountsGetById', 'customerAccountId', customerAccountId);
            const localVarPath = `/admin/customer_accounts/{customerAccountId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {AdminCustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsUpdate: (customerAccountId, customerAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('adminCustomerAccountsUpdate', 'customerAccountId', customerAccountId);
            // verify required parameter 'customerAccount' is not null or undefined
            (0, common_1.assertParamExists)('adminCustomerAccountsUpdate', 'customerAccount', customerAccount);
            const localVarPath = `/admin/customer_accounts/{customerAccountId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerAccount, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates an identity
         * @param {string} identityId
         * @param {AdminIdentitiesUpdateRequest} identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIdentitiesUpdate: (identityId, identity, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'identityId' is not null or undefined
            (0, common_1.assertParamExists)('adminIdentitiesUpdate', 'identityId', identityId);
            // verify required parameter 'identity' is not null or undefined
            (0, common_1.assertParamExists)('adminIdentitiesUpdate', 'identity', identity);
            const localVarPath = `/admin/identities/{identityId}`
                .replace(`{${"identityId"}}`, encodeURIComponent(String(identityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(identity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of organizations
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCount: (name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/organizations?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (customerAccount !== undefined) {
                localVarQueryParameter['customer_account'] = customerAccount;
            }
            if (deactivatedDate !== undefined) {
                localVarQueryParameter['deactivated_date'] = deactivatedDate;
            }
            if (isDemo !== undefined) {
                localVarQueryParameter['is_demo'] = isDemo;
            }
            if (subdomain !== undefined) {
                localVarQueryParameter['subdomain'] = subdomain;
            }
            if (subdomainKey !== undefined) {
                localVarQueryParameter['subdomain_key'] = subdomainKey;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates an org
         * @param {AdminOrganizationsCreateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCreate: (organization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('adminOrganizationsCreate', 'organization', organization);
            const localVarPath = `/admin/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organization, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of organizations
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsGet: (sort, name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (customerAccount !== undefined) {
                localVarQueryParameter['customer_account'] = customerAccount;
            }
            if (deactivatedDate !== undefined) {
                localVarQueryParameter['deactivated_date'] = deactivatedDate;
            }
            if (isDemo !== undefined) {
                localVarQueryParameter['is_demo'] = isDemo;
            }
            if (subdomain !== undefined) {
                localVarQueryParameter['subdomain'] = subdomain;
            }
            if (subdomainKey !== undefined) {
                localVarQueryParameter['subdomain_key'] = subdomainKey;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates an org
         * @param {string} organizationId
         * @param {AdminOrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsUpdate: (organizationId, organization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('adminOrganizationsUpdate', 'organizationId', organizationId);
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('adminOrganizationsUpdate', 'organization', organization);
            const localVarPath = `/admin/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organization, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a saml config
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigDelete: (samlConfigId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'samlConfigId' is not null or undefined
            (0, common_1.assertParamExists)('adminSAMLConfigDelete', 'samlConfigId', samlConfigId);
            const localVarPath = `/admin/saml_configs/{samlConfigId}`
                .replace(`{${"samlConfigId"}}`, encodeURIComponent(String(samlConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a saml config by id
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigGetById: (samlConfigId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'samlConfigId' is not null or undefined
            (0, common_1.assertParamExists)('adminSAMLConfigGetById', 'samlConfigId', samlConfigId);
            const localVarPath = `/admin/saml_configs/{samlConfigId}`
                .replace(`{${"samlConfigId"}}`, encodeURIComponent(String(samlConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a saml config
         * @param {string} samlConfigId
         * @param {AdminSAMLConfigUpdateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigUpdate: (samlConfigId, samlConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'samlConfigId' is not null or undefined
            (0, common_1.assertParamExists)('adminSAMLConfigUpdate', 'samlConfigId', samlConfigId);
            // verify required parameter 'samlConfig' is not null or undefined
            (0, common_1.assertParamExists)('adminSAMLConfigUpdate', 'samlConfig', samlConfig);
            const localVarPath = `/admin/saml_configs/{samlConfigId}`
                .replace(`{${"samlConfigId"}}`, encodeURIComponent(String(samlConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(samlConfig, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of saml configs
         * @param {string} [sort]
         * @param {string} [customerAccount]
         * @param {string} [domain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigsGet: (sort, customerAccount, domain, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/saml_configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (customerAccount !== undefined) {
                localVarQueryParameter['customer_account'] = customerAccount;
            }
            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount: (organizationId, decommissioned, name, building, pinType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('assetsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/assets?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates an asset
         * @param {string} buildingId
         * @param {AssetsCreateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCreate: (buildingId, asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('assetsCreate', 'buildingId', buildingId);
            // verify required parameter 'asset' is not null or undefined
            (0, common_1.assertParamExists)('assetsCreate', 'asset', asset);
            const localVarPath = `/buildings/{buildingId}/assets`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(asset, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetById: (buildingId, assetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('assetsGetById', 'buildingId', buildingId);
            // verify required parameter 'assetId' is not null or undefined
            (0, common_1.assertParamExists)('assetsGetById', 'assetId', assetId);
            const localVarPath = `/buildings/{buildingId}/assets/{assetId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {AssetsUpdateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdate: (buildingId, assetId, asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('assetsUpdate', 'buildingId', buildingId);
            // verify required parameter 'assetId' is not null or undefined
            (0, common_1.assertParamExists)('assetsUpdate', 'assetId', assetId);
            // verify required parameter 'asset' is not null or undefined
            (0, common_1.assertParamExists)('assetsUpdate', 'asset', asset);
            const localVarPath = `/buildings/{buildingId}/assets/{assetId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(asset, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount: (building, linksEntityId, linksEntityType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'building', building);
            // verify required parameter 'linksEntityId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'linksEntityId', linksEntityId);
            // verify required parameter 'linksEntityType' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCount', 'linksEntityType', linksEntityType);
            const localVarPath = `/buildings/{building}/attachments?count=true`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linksEntityId !== undefined) {
                localVarQueryParameter['links.entity_id'] = linksEntityId;
            }
            if (linksEntityType !== undefined) {
                localVarQueryParameter['links.entity_type'] = linksEntityType;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate: (building, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCreate', 'building', building);
            // verify required parameter 'attachment' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsCreate', 'attachment', attachment);
            const localVarPath = `/buildings/{building}/attachments`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding: (building, linksEntityId, linksEntityType, deleteDate, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'building', building);
            // verify required parameter 'linksEntityId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'linksEntityId', linksEntityId);
            // verify required parameter 'linksEntityType' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByBuilding', 'linksEntityType', linksEntityType);
            const localVarPath = `/buildings/{building}/attachments`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linksEntityId !== undefined) {
                localVarQueryParameter['links.entity_id'] = linksEntityId;
            }
            if (linksEntityType !== undefined) {
                localVarQueryParameter['links.entity_type'] = linksEntityType;
            }
            if (deleteDate !== undefined) {
                localVarQueryParameter['delete_date'] = deleteDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get attachments by organization, entity id, and entity type
         * @param {string} organization
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByOrganization: (organization, linksEntityId, linksEntityType, deleteDate, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByOrganization', 'organization', organization);
            // verify required parameter 'linksEntityId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByOrganization', 'linksEntityId', linksEntityId);
            // verify required parameter 'linksEntityType' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsGetByOrganization', 'linksEntityType', linksEntityType);
            const localVarPath = `/organizations/{organization}/attachments`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linksEntityId !== undefined) {
                localVarQueryParameter['links.entity_id'] = linksEntityId;
            }
            if (linksEntityType !== undefined) {
                localVarQueryParameter['links.entity_type'] = linksEntityType;
            }
            if (deleteDate !== undefined) {
                localVarQueryParameter['delete_date'] = deleteDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate: (buildingId, attachmentId, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'buildingId', buildingId);
            // verify required parameter 'attachmentId' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'attachmentId', attachmentId);
            // verify required parameter 'attachment' is not null or undefined
            (0, common_1.assertParamExists)('attachmentsUpdate', 'attachment', attachment);
            const localVarPath = `/buildings/{buildingId}/attachments/{attachmentId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(attachment, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Federate an account
         * @param {AuthFederateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFederate: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('authFederate', 'body', body);
            const localVarPath = `/auth/federate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Requests an email to reset password
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authForgotPassword: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('authForgotPassword', 'body', body);
            const localVarPath = `/auth/forgot_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Login to a profile
         * @param {AuthPasswordLoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordLogin: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('authPasswordLogin', 'body', body);
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Registers a user under a customer account
         * @param {AuthRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegister: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('authRegister', 'body', body);
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Sends a verfication email to a newly created account
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendValidationEmail: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('authSendValidationEmail', 'body', body);
            const localVarPath = `/auth/send_validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a floor within a building
         * @param {string} buildingId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingLevelsGetById: (buildingId, levelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('buildingLevelsGetById', 'buildingId', buildingId);
            // verify required parameter 'levelId' is not null or undefined
            (0, common_1.assertParamExists)('buildingLevelsGetById', 'levelId', levelId);
            const localVarPath = `/buildings/{buildingId}/levels/{levelId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"levelId"}}`, encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsCount: (organizationId, name, address, city, state, postalCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/buildings?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetById: (organizationId, buildingId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsGetById', 'organizationId', organizationId);
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsGetById', 'buildingId', buildingId);
            const localVarPath = `/organizations/{organizationId}/buildings/{buildingId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization: (organizationId, sort, limit, skip, name, address, city, state, postalCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/buildings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {BuildingsUpdateRequest} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsUpdate: (organizationId, buildingId, building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsUpdate', 'organizationId', organizationId);
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('buildingsUpdate', 'buildingId', buildingId);
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('buildingsUpdate', 'building', building);
            const localVarPath = `/organizations/{organizationId}/buildings/{buildingId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(building, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('cancelImport', 'importId', importId);
            const localVarPath = `/my_imports/{importId}`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet: (catalogId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogGet', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemGet: (catalogId, itemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemGet', 'catalogId', catalogId);
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemGet', 'itemId', itemId);
            const localVarPath = `/catalogs/{catalogId}/items/{itemId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount: (catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCount', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}/items?count=true`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }
            if (quantityUnit !== undefined) {
                localVarQueryParameter['quantity_unit'] = quantityUnit;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sizeUnit !== undefined) {
                localVarQueryParameter['size_unit'] = sizeUnit;
            }
            if (frequency !== undefined) {
                localVarQueryParameter['frequency'] = frequency;
            }
            if (materialsUnitCostCents !== undefined) {
                localVarQueryParameter['materials_unit_cost_cents'] = materialsUnitCostCents;
            }
            if (laborUnitCostCents !== undefined) {
                localVarQueryParameter['labor_unit_cost_cents'] = laborUnitCostCents;
            }
            if (equipmentUnitCostCents !== undefined) {
                localVarQueryParameter['equipment_unit_cost_cents'] = equipmentUnitCostCents;
            }
            if (unitCostCents !== undefined) {
                localVarQueryParameter['unit_cost_cents'] = unitCostCents;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate: (catalogId, catalogItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCreate', 'catalogId', catalogId);
            // verify required parameter 'catalogItem' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsCreate', 'catalogItem', catalogItem);
            const localVarPath = `/catalogs/{catalogId}/items`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogItem, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes an item from a catalog
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsDelete: (catalogId, itemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsDelete', 'catalogId', catalogId);
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsDelete', 'itemId', itemId);
            const localVarPath = `/catalogs/{catalogId}/items/{itemId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet: (catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsGet', 'catalogId', catalogId);
            const localVarPath = `/catalogs/{catalogId}/items`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (itemId !== undefined) {
                localVarQueryParameter['item_id'] = itemId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }
            if (quantityUnit !== undefined) {
                localVarQueryParameter['quantity_unit'] = quantityUnit;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sizeUnit !== undefined) {
                localVarQueryParameter['size_unit'] = sizeUnit;
            }
            if (frequency !== undefined) {
                localVarQueryParameter['frequency'] = frequency;
            }
            if (materialsUnitCostCents !== undefined) {
                localVarQueryParameter['materials_unit_cost_cents'] = materialsUnitCostCents;
            }
            if (laborUnitCostCents !== undefined) {
                localVarQueryParameter['labor_unit_cost_cents'] = laborUnitCostCents;
            }
            if (equipmentUnitCostCents !== undefined) {
                localVarQueryParameter['equipment_unit_cost_cents'] = equipmentUnitCostCents;
            }
            if (unitCostCents !== undefined) {
                localVarQueryParameter['unit_cost_cents'] = unitCostCents;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate: (catalogId, itemId, catalogItem, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'catalogId', catalogId);
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'itemId', itemId);
            // verify required parameter 'catalogItem' is not null or undefined
            (0, common_1.assertParamExists)('catalogItemsUpdate', 'catalogItem', catalogItem);
            const localVarPath = `/catalogs/{catalogId}/items/{itemId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogItem, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate: (catalogId, catalog, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalogId' is not null or undefined
            (0, common_1.assertParamExists)('catalogUpdate', 'catalogId', catalogId);
            // verify required parameter 'catalog' is not null or undefined
            (0, common_1.assertParamExists)('catalogUpdate', 'catalog', catalog);
            const localVarPath = `/catalogs/{catalogId}`
                .replace(`{${"catalogId"}}`, encodeURIComponent(String(catalogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalog, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount: (name, modifiedDateMs, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/catalogs?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (modifiedDateMs !== undefined) {
                localVarQueryParameter['modified_date_ms'] = modifiedDateMs;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate: (catalog, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'catalog' is not null or undefined
            (0, common_1.assertParamExists)('catalogsCreate', 'catalog', catalog);
            const localVarPath = `/catalogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalog, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet: (name, modifiedDateMs, limit, sort, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/catalogs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (modifiedDateMs !== undefined) {
                localVarQueryParameter['modified_date_ms'] = modifiedDateMs;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of checklist templates for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [complianceCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGet: (organizationId, limit, skip, sortBy, status, id, name, complianceCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('checklistTemplatesGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/checklist_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a checklist template in the given organization
         * @param {string} organizationId
         * @param {string} checklistTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGetById: (organizationId, checklistTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('checklistTemplatesGetById', 'organizationId', organizationId);
            // verify required parameter 'checklistTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('checklistTemplatesGetById', 'checklistTemplateId', checklistTemplateId);
            const localVarPath = `/organizations/{organizationId}/checklist_templates/{checklistTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsCount: (organizationId, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('checklistsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/checklists?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            if (inspectionProgramId !== undefined) {
                localVarQueryParameter['inspection_program._id'] = inspectionProgramId;
            }
            if (inspectionProgramName !== undefined) {
                localVarQueryParameter['inspection_program.name'] = inspectionProgramName;
            }
            if (inspectionProgramPriority !== undefined) {
                localVarQueryParameter['inspection_program.priority'] = inspectionProgramPriority;
            }
            if (inspectionProgramNumber !== undefined) {
                localVarQueryParameter['inspection_program.number'] = inspectionProgramNumber;
            }
            if (inspectionProgramStatus !== undefined) {
                localVarQueryParameter['inspection_program.status'] = inspectionProgramStatus;
            }
            if (inspectionId !== undefined) {
                localVarQueryParameter['inspection._id'] = inspectionId;
            }
            if (inspectionStartDate !== undefined) {
                localVarQueryParameter['inspection.start_date'] = inspectionStartDate;
            }
            if (inspectionDueDate !== undefined) {
                localVarQueryParameter['inspection.due_date'] = inspectionDueDate;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (completedDate !== undefined) {
                localVarQueryParameter['completed_date'] = completedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsGet: (organizationId, limit, skip, sortBy, asset, building, status, complianceCode, checklistTemplate, completedDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('checklistsGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/checklists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (completedDate !== undefined) {
                localVarQueryParameter['completed_date'] = completedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the stats of checklists for the given organization
         * @param {string} organizationId
         * @param {string} groupField
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsStatsGroup: (organizationId, groupField, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('checklistsStatsGroup', 'organizationId', organizationId);
            // verify required parameter 'groupField' is not null or undefined
            (0, common_1.assertParamExists)('checklistsStatsGroup', 'groupField', groupField);
            const localVarPath = `/stats/organizations/{organizationId}/checklists?group_field={groupField}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"groupField"}}`, encodeURIComponent(String(groupField)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            if (inspectionProgramId !== undefined) {
                localVarQueryParameter['inspection_program._id'] = inspectionProgramId;
            }
            if (inspectionProgramName !== undefined) {
                localVarQueryParameter['inspection_program.name'] = inspectionProgramName;
            }
            if (inspectionProgramPriority !== undefined) {
                localVarQueryParameter['inspection_program.priority'] = inspectionProgramPriority;
            }
            if (inspectionProgramNumber !== undefined) {
                localVarQueryParameter['inspection_program.number'] = inspectionProgramNumber;
            }
            if (inspectionProgramStatus !== undefined) {
                localVarQueryParameter['inspection_program.status'] = inspectionProgramStatus;
            }
            if (inspectionId !== undefined) {
                localVarQueryParameter['inspection._id'] = inspectionId;
            }
            if (inspectionStartDate !== undefined) {
                localVarQueryParameter['inspection.start_date'] = inspectionStartDate;
            }
            if (inspectionDueDate !== undefined) {
                localVarQueryParameter['inspection.due_date'] = inspectionDueDate;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (completedDate !== undefined) {
                localVarQueryParameter['completed_date'] = completedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/third_party/ckeditor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Generate a confirmation code to login
         * @param {ConfirmationCodeCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationCodeCreate: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('confirmationCodeCreate', 'body', body);
            const localVarPath = `/auth/confirmation_codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get cost data for the provided line number and catalog in the building\'s catalog location and release
         * @param {string} buildingId
         * @param {CostDataCatalog} catalogType
         * @param {string} lineNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costDataGetByBuilding: (buildingId, catalogType, lineNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('costDataGetByBuilding', 'buildingId', buildingId);
            // verify required parameter 'catalogType' is not null or undefined
            (0, common_1.assertParamExists)('costDataGetByBuilding', 'catalogType', catalogType);
            // verify required parameter 'lineNumber' is not null or undefined
            (0, common_1.assertParamExists)('costDataGetByBuilding', 'lineNumber', lineNumber);
            const localVarPath = `/buildings/{buildingId}/costdata/{catalogType}/cost_lines/{lineNumber}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"catalogType"}}`, encodeURIComponent(String(catalogType)))
                .replace(`{${"lineNumber"}}`, encodeURIComponent(String(lineNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of cost lines by building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByBuilding: (buildingId, limit, skip, asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesGetByBuilding', 'buildingId', buildingId);
            const localVarPath = `/buildings/{buildingId}/cost_lines`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a cost line by id in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetById: (buildingId, costLineId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesGetById', 'buildingId', buildingId);
            // verify required parameter 'costLineId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesGetById', 'costLineId', costLineId);
            const localVarPath = `/buildings/{buildingId}/cost_lines/{costLineId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"costLineId"}}`, encodeURIComponent(String(costLineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of cost lines by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByOrganization: (organizationId, limit, skip, building, asset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/cost_lines`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (asset !== undefined) {
                localVarQueryParameter['asset'] = asset;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a cost line in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {CostLinesUpdateRequest} costLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesUpdate: (buildingId, costLineId, costLine, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesUpdate', 'buildingId', buildingId);
            // verify required parameter 'costLineId' is not null or undefined
            (0, common_1.assertParamExists)('costLinesUpdate', 'costLineId', costLineId);
            // verify required parameter 'costLine' is not null or undefined
            (0, common_1.assertParamExists)('costLinesUpdate', 'costLine', costLine);
            const localVarPath = `/buildings/{buildingId}/cost_lines/{costLineId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"costLineId"}}`, encodeURIComponent(String(costLineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(costLine, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizations: (customerAccountId, name, subdomainKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('countOrganizations', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations?count=true`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (subdomainKey !== undefined) {
                localVarQueryParameter['subdomain_key'] = subdomainKey;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {CreateOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestration: (customerAccountId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('createCustomerAccountOrchestration', 'customerAccountId', customerAccountId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createCustomerAccountOrchestration', 'body', body);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {CreateStepsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestrationSteps: (customerAccountId, orchestrationId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('createCustomerAccountOrchestrationSteps', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('createCustomerAccountOrchestrationSteps', 'orchestrationId', orchestrationId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createCustomerAccountOrchestrationSteps', 'body', body);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}/steps`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates an organizations within a customer account
         * @param {string} customerAccountId
         * @param {CreateOrganizationRequest} createOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: (customerAccountId, createOrganizationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('createOrganization', 'customerAccountId', customerAccountId);
            // verify required parameter 'createOrganizationRequest' is not null or undefined
            (0, common_1.assertParamExists)('createOrganization', 'createOrganizationRequest', createOrganizationRequest);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Create a new orchestration
         * @param {CreateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestration: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createSiteAdminOrchestration', 'body', body);
            const localVarPath = `/admin/orchestrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Create steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {Array<CreateStepRequest>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestrationSteps: (orchestrationId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('createSiteAdminOrchestrationSteps', 'orchestrationId', orchestrationId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createSiteAdminOrchestrationSteps', 'body', body);
            const localVarPath = `/admin/orchestrations/{orchestrationId}/steps`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create a new theme for the customer account
         * @param {string} customerAccountId
         * @param {CreateThemeRequest} createThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTheme: (customerAccountId, createThemeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('createTheme', 'customerAccountId', customerAccountId);
            // verify required parameter 'createThemeRequest' is not null or undefined
            (0, common_1.assertParamExists)('createTheme', 'createThemeRequest', createThemeRequest);
            const localVarPath = `/customer_accounts/{customerAccountId}/themes`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createThemeRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * creates a JWT for the email, code and customer account combination
         * @param {CreateTokenRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('createToken', 'body', body);
            const localVarPath = `/auth/confirmation_codes/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationDelete: (organizationId, customFieldAssociationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationDelete', 'organizationId', organizationId);
            // verify required parameter 'customFieldAssociationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationDelete', 'customFieldAssociationId', customFieldAssociationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_associations/{customFieldAssociationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldAssociationId"}}`, encodeURIComponent(String(customFieldAssociationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationGet: (organizationId, customFieldAssociationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationGet', 'organizationId', organizationId);
            // verify required parameter 'customFieldAssociationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationGet', 'customFieldAssociationId', customFieldAssociationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_associations/{customFieldAssociationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldAssociationId"}}`, encodeURIComponent(String(customFieldAssociationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the custom field association for the given organization
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {CustomFieldAssociationUpdateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationUpdate: (organizationId, customFieldAssociationId, customFieldAssociation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationUpdate', 'organizationId', organizationId);
            // verify required parameter 'customFieldAssociationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationUpdate', 'customFieldAssociationId', customFieldAssociationId);
            // verify required parameter 'customFieldAssociation' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationUpdate', 'customFieldAssociation', customFieldAssociation);
            const localVarPath = `/organizations/{organizationId}/custom_field_associations/{customFieldAssociationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldAssociationId"}}`, encodeURIComponent(String(customFieldAssociationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldAssociation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a custom field association
         * @param {string} organizationId
         * @param {CustomFieldAssociationsCreateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsCreate: (organizationId, customFieldAssociation, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationsCreate', 'organizationId', organizationId);
            // verify required parameter 'customFieldAssociation' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationsCreate', 'customFieldAssociation', customFieldAssociation);
            const localVarPath = `/organizations/{organizationId}/custom_field_associations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldAssociation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of custom field associations for the given organization
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsGet: (organizationId, linkedEntityType, customFieldDefinition, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldAssociationsGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_associations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linkedEntityType !== undefined) {
                localVarQueryParameter['linked_entity_type'] = linkedEntityType;
            }
            if (customFieldDefinition !== undefined) {
                localVarQueryParameter['custom_field_definition'] = customFieldDefinition;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionDelete: (organizationId, customFieldDefinitionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionDelete', 'organizationId', organizationId);
            // verify required parameter 'customFieldDefinitionId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionDelete', 'customFieldDefinitionId', customFieldDefinitionId);
            const localVarPath = `/organizations/{organizationId}/custom_field_definitions/{customFieldDefinitionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldDefinitionId"}}`, encodeURIComponent(String(customFieldDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionGet: (organizationId, customFieldDefinitionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionGet', 'organizationId', organizationId);
            // verify required parameter 'customFieldDefinitionId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionGet', 'customFieldDefinitionId', customFieldDefinitionId);
            const localVarPath = `/organizations/{organizationId}/custom_field_definitions/{customFieldDefinitionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldDefinitionId"}}`, encodeURIComponent(String(customFieldDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the custom field definition for the given organization
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {CustomFieldDefinitionUpdateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionUpdate: (organizationId, customFieldDefinitionId, customFieldDefinition, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionUpdate', 'organizationId', organizationId);
            // verify required parameter 'customFieldDefinitionId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionUpdate', 'customFieldDefinitionId', customFieldDefinitionId);
            // verify required parameter 'customFieldDefinition' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionUpdate', 'customFieldDefinition', customFieldDefinition);
            const localVarPath = `/organizations/{organizationId}/custom_field_definitions/{customFieldDefinitionId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldDefinitionId"}}`, encodeURIComponent(String(customFieldDefinitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldDefinition, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a custom field definition
         * @param {string} organizationId
         * @param {CustomFieldDefinitionsCreateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsCreate: (organizationId, customFieldDefinition, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionsCreate', 'organizationId', organizationId);
            // verify required parameter 'customFieldDefinition' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionsCreate', 'customFieldDefinition', customFieldDefinition);
            const localVarPath = `/organizations/{organizationId}/custom_field_definitions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldDefinition, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of custom field definitions for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsGet: (organizationId, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldDefinitionsGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_definitions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueDelete: (organizationId, customFieldEnumValueId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueDelete', 'organizationId', organizationId);
            // verify required parameter 'customFieldEnumValueId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueDelete', 'customFieldEnumValueId', customFieldEnumValueId);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values/{customFieldEnumValueId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldEnumValueId"}}`, encodeURIComponent(String(customFieldEnumValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueGet: (organizationId, customFieldEnumValueId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueGet', 'organizationId', organizationId);
            // verify required parameter 'customFieldEnumValueId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueGet', 'customFieldEnumValueId', customFieldEnumValueId);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values/{customFieldEnumValueId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldEnumValueId"}}`, encodeURIComponent(String(customFieldEnumValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the custom field enum value for the given id
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {CustomFieldEnumValueUpdateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueUpdate: (organizationId, customFieldEnumValueId, customFieldEnumValue, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueUpdate', 'organizationId', organizationId);
            // verify required parameter 'customFieldEnumValueId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueUpdate', 'customFieldEnumValueId', customFieldEnumValueId);
            // verify required parameter 'customFieldEnumValue' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValueUpdate', 'customFieldEnumValue', customFieldEnumValue);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values/{customFieldEnumValueId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldEnumValueId"}}`, encodeURIComponent(String(customFieldEnumValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldEnumValue, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Count the custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCount: (organizationId, customFieldDefinition, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValuesCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customFieldDefinition !== undefined) {
                localVarQueryParameter['custom_field_definition'] = customFieldDefinition;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a custom field enum value
         * @param {string} organizationId
         * @param {CustomFieldEnumValuesCreateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCreate: (organizationId, customFieldEnumValue, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValuesCreate', 'organizationId', organizationId);
            // verify required parameter 'customFieldEnumValue' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValuesCreate', 'customFieldEnumValue', customFieldEnumValue);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldEnumValue, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesGet: (organizationId, customFieldDefinition, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldEnumValuesGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_enum_values`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customFieldDefinition !== undefined) {
                localVarQueryParameter['custom_field_definition'] = customFieldDefinition;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the custom field values for the given organization on organizations only
         * @param {string} organizationId
         * @param {string} [linkedEntityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesGet: (organizationId, linkedEntityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldValuesGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/custom_field_values/organization`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linkedEntityId !== undefined) {
                localVarQueryParameter['linked_entity_id'] = linkedEntityId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update the given custom field value for the given organization
         * @param {string} organizationId
         * @param {string} customFieldValueId
         * @param {CustomFieldValuesUpdateRequest} customFieldValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesUpdate: (organizationId, customFieldValueId, customFieldValue, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldValuesUpdate', 'organizationId', organizationId);
            // verify required parameter 'customFieldValueId' is not null or undefined
            (0, common_1.assertParamExists)('customFieldValuesUpdate', 'customFieldValueId', customFieldValueId);
            // verify required parameter 'customFieldValue' is not null or undefined
            (0, common_1.assertParamExists)('customFieldValuesUpdate', 'customFieldValue', customFieldValue);
            const localVarPath = `/organizations/{organizationId}/custom_field_values/{customFieldValueId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"customFieldValueId"}}`, encodeURIComponent(String(customFieldValueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customFieldValue, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionDelete: (customerAccountId, defaultPermissionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionDelete', 'customerAccountId', customerAccountId);
            // verify required parameter 'defaultPermissionId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionDelete', 'defaultPermissionId', defaultPermissionId);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions/{defaultPermissionId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"defaultPermissionId"}}`, encodeURIComponent(String(defaultPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionGet: (customerAccountId, defaultPermissionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionGet', 'customerAccountId', customerAccountId);
            // verify required parameter 'defaultPermissionId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionGet', 'defaultPermissionId', defaultPermissionId);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions/{defaultPermissionId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"defaultPermissionId"}}`, encodeURIComponent(String(defaultPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionUpdate: (customerAccountId, defaultPermissionId, defaultPermission, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionUpdate', 'customerAccountId', customerAccountId);
            // verify required parameter 'defaultPermissionId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionUpdate', 'defaultPermissionId', defaultPermissionId);
            // verify required parameter 'defaultPermission' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionUpdate', 'defaultPermission', defaultPermission);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions/{defaultPermissionId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"defaultPermissionId"}}`, encodeURIComponent(String(defaultPermissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(defaultPermission, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of default permissions for a customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCount: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionsCount', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions?count=true`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCreate: (customerAccountId, defaultPermission, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionsCreate', 'customerAccountId', customerAccountId);
            // verify required parameter 'defaultPermission' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionsCreate', 'defaultPermission', defaultPermission);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(defaultPermission, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [externalGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsGet: (customerAccountId, limit, skip, sort, name, externalGroup, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsDefaultPermissionsGet', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/default_permissions`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (externalGroup !== undefined) {
                localVarQueryParameter['external_group'] = externalGroup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsGetById: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsGetById', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {CustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsUpdate: (customerAccountId, customerAccount, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsUpdate', 'customerAccountId', customerAccountId);
            // verify required parameter 'customerAccount' is not null or undefined
            (0, common_1.assertParamExists)('customerAccountsUpdate', 'customerAccount', customerAccount);
            const localVarPath = `/customer_accounts/{customerAccountId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customerAccount, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization: (customerAccountId, organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrganization', 'customerAccountId', customerAccountId);
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('deleteOrganization', 'organizationId', organizationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations/{organizationId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTheme: (customerAccountId, themeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('deleteTheme', 'customerAccountId', customerAccountId);
            // verify required parameter 'themeId' is not null or undefined
            (0, common_1.assertParamExists)('deleteTheme', 'themeId', themeId);
            const localVarPath = `/customer_accounts/{customerAccountId}/themes/{themeId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"themeId"}}`, encodeURIComponent(String(themeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding: (building, archived, limit, skip, sort, name, extension, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('documentsGetByBuilding', 'building', building);
            const localVarPath = `/buildings/{building}/docs`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (extension !== undefined) {
                localVarQueryParameter['extension'] = extension;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload: (building, file, attachment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('documentsUpload', 'building', building);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('documentsUpload', 'file', file);
            const localVarPath = `/buildings/{building}/docs`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (attachment !== undefined) {
                localVarFormParams.append('attachment', attachment);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of field groups by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldGroupsGetByOrganization: (organizationId, name, context, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('fieldGroupsGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/field_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate: (organization, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('fileCreate', 'organization', organization);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('fileCreate', 'file', file);
            const localVarPath = `/organizations/{organization}/files`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(file, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get file
         * @param {string} organization
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGet: (organization, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('fileGet', 'organization', organization);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('fileGet', 'file', file);
            const localVarPath = `/organizations/{organization}/files/{file}`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)))
                .replace(`{${"file"}}`, encodeURIComponent(String(file)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload: (organization, file, fileAction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'organization', organization);
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'file', file);
            // verify required parameter 'fileAction' is not null or undefined
            (0, common_1.assertParamExists)('filesCompleteUpload', 'fileAction', fileAction);
            const localVarPath = `/organizations/{organization}/files/{file}`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)))
                .replace(`{${"file"}}`, encodeURIComponent(String(file)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fileAction, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get file
         * @param {string} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet: (organization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('filesGet', 'organization', organization);
            const localVarPath = `/organizations/{organization}/files`
                .replace(`{${"organization"}}`, encodeURIComponent(String(organization)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/flags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the active theme for the customer account (if there is one)
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTheme: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getActiveTheme', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/active_theme`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the importable fields for assets
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetImportFields: (targetId, updatable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/import_entities/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (updatable !== undefined) {
                localVarQueryParameter['updatable'] = updatable;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the authentication methods allowed by the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthnMethods: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getAuthnMethods', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/authn_methods`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the importable fields for buildings
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingImportFields: (targetId, updatable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/import/import_entities/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (updatable !== undefined) {
                localVarQueryParameter['updatable'] = updatable;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult: (importId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('getCSVResult', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows_csv`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestration: (customerAccountId, orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestration', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestration', 'orchestrationId', orchestrationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationSteps: (customerAccountId, orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationSteps', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationSteps', 'orchestrationId', orchestrationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}/steps`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get steps results as CSV for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsCSV: (customerAccountId, orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationStepsCSV', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationStepsCSV', 'orchestrationId', orchestrationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}/steps_csv`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get steps statistics for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsStats: (customerAccountId, orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationStepsStats', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrationStepsStats', 'orchestrationId', orchestrationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}/steps_stats`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get orchestrations for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrations: (customerAccountId, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccountOrchestrations', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get customer accounts that belong to email and code combination
         * @param {GetCustomerAccountsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccounts: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('getCustomerAccounts', 'body', body);
            const localVarPath = `/auth/confirmation_codes/customer_accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets an organization within a customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationGetById: (customerAccountId, organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getOrganizationGetById', 'customerAccountId', customerAccountId);
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('getOrganizationGetById', 'organizationId', organizationId);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations/{organizationId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: (customerAccountId, name, subdomainKey, sort, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getOrganizations', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (subdomainKey !== undefined) {
                localVarQueryParameter['subdomain_key'] = subdomainKey;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows: (importId, status, limit, sort, startKey, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('getRows', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (startKey !== undefined) {
                localVarQueryParameter['start_key'] = startKey;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestration: (orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getSiteAdminOrchestration', 'orchestrationId', orchestrationId);
            const localVarPath = `/admin/orchestrations/{orchestrationId}`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {number} [limit] Maximum number of steps to return
         * @param {string} [startKey] Pagination start key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationSteps: (orchestrationId, status, limit, startKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getSiteAdminOrchestrationSteps', 'orchestrationId', orchestrationId);
            const localVarPath = `/admin/orchestrations/{orchestrationId}/steps`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startKey !== undefined) {
                localVarQueryParameter['start_key'] = startKey;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get steps results as CSV for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsCSV: (orchestrationId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getSiteAdminOrchestrationStepsCSV', 'orchestrationId', orchestrationId);
            const localVarPath = `/admin/orchestrations/{orchestrationId}/steps_csv`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get steps statistics for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsStats: (orchestrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('getSiteAdminOrchestrationStepsStats', 'orchestrationId', orchestrationId);
            const localVarPath = `/admin/orchestrations/{orchestrationId}/steps_stats`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get orchestrations
         * @param {OrchestrationTargetEntity} [targetEntity] Filter orchestrations by target entity
         * @param {string} [targetId] Filter orchestrations by target ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrations: (targetEntity, targetId, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orchestrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (targetEntity !== undefined) {
                localVarQueryParameter['target_entity'] = targetEntity;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheme: (customerAccountId, themeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getTheme', 'customerAccountId', customerAccountId);
            // verify required parameter 'themeId' is not null or undefined
            (0, common_1.assertParamExists)('getTheme', 'themeId', themeId);
            const localVarPath = `/customer_accounts/{customerAccountId}/themes/{themeId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"themeId"}}`, encodeURIComponent(String(themeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of themes for the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemes: (customerAccountId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('getThemes', 'customerAccountId', customerAccountId);
            const localVarPath = `/customer_accounts/{customerAccountId}/themes`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCountUsers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/identity/users?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a JWT for the email and password combination
         * @param {AdminOrganizationsUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCreateToken: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('identityCreateToken', 'body', body);
            const localVarPath = `/identity/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets data for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {string} [sisenseRole]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGetUsers: (sisenseRole, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/identity/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sisenseRole !== undefined) {
                localVarQueryParameter['sisense_role'] = sisenseRole;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV: (targetId, targetEntity, importEntity, files, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'targetId' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'targetId', targetId);
            // verify required parameter 'targetEntity' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'targetEntity', targetEntity);
            // verify required parameter 'importEntity' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'importEntity', importEntity);
            // verify required parameter 'files' is not null or undefined
            (0, common_1.assertParamExists)('importCSV', 'files', files);
            const localVarPath = `/my_imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (targetId !== undefined) {
                localVarFormParams.append('target_id', targetId);
            }
            if (targetEntity !== undefined) {
                localVarFormParams.append('target_entity', targetEntity);
            }
            if (importEntity !== undefined) {
                localVarFormParams.append('import_entity', importEntity);
            }
            if (files !== undefined) {
                localVarFormParams.append('files', files);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks the row actions stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowActionsStats: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('importRowActionsStats', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/row_actions_stats`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('importRowsStats', 'importId', importId);
            const localVarPath = `/my_imports/{importId}/rows_stats`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [number]
         * @param {string} [name]
         * @param {string} [priority]
         * @param {string} [checklistTemplate]
         * @param {string} [assignees]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGet: (organizationId, limit, skip, sortBy, status, number, name, priority, checklistTemplate, assignees, building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('inspectionProgramsGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/inspection_programs`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (assignees !== undefined) {
                localVarQueryParameter['assignees'] = assignees;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGetCount: (organizationId, limit, skip, sortBy, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('inspectionProgramsGetCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/inspection_programs?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets all floors within an organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsByOrganization: (organizationId, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('levelsByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/levels`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a floor within an organization
         * @param {string} organizationId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsGetById: (organizationId, levelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('levelsGetById', 'organizationId', organizationId);
            // verify required parameter 'levelId' is not null or undefined
            (0, common_1.assertParamExists)('levelsGetById', 'levelId', levelId);
            const localVarPath = `/organizations/{organizationId}/levels/{levelId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"levelId"}}`, encodeURIComponent(String(levelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Cancel the export process for the given exportId
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCancel: (exportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'exportId' is not null or undefined
            (0, common_1.assertParamExists)('myExportsCancel', 'exportId', exportId);
            const localVarPath = `/my_exports/exports/{exportId}`
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Process the given export request
         * @param {MyExportsCreateRequest} [myExportsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCreate: (myExportsCreateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/my_exports/exports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(myExportsCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the export by its id
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsGet: (exportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'exportId' is not null or undefined
            (0, common_1.assertParamExists)('myExportsGet', 'exportId', exportId);
            const localVarPath = `/my_exports/exports/{exportId}`
                .replace(`{${"exportId"}}`, encodeURIComponent(String(exportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of exports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [exportEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsList: (limit, startKey, status, targetEntity, targetId, exportEntity, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/my_exports/exports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startKey !== undefined) {
                localVarQueryParameter['start_key'] = startKey;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (targetEntity !== undefined) {
                localVarQueryParameter['target_entity'] = targetEntity;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (exportEntity !== undefined) {
                localVarQueryParameter['export_entity'] = exportEntity;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the import by its id
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsGet: (importId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'importId' is not null or undefined
            (0, common_1.assertParamExists)('myImportsGet', 'importId', importId);
            const localVarPath = `/my_imports/{importId}`
                .replace(`{${"importId"}}`, encodeURIComponent(String(importId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of imports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [importEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsList: (limit, startKey, status, targetEntity, targetId, importEntity, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/my_imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startKey !== undefined) {
                localVarQueryParameter['start_key'] = startKey;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (targetEntity !== undefined) {
                localVarQueryParameter['target_entity'] = targetEntity;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (importEntity !== undefined) {
                localVarQueryParameter['import_entity'] = importEntity;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the count of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCount: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organizations?count=true`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('organizationsDelete', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet: (subdomain, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (subdomain !== undefined) {
                localVarQueryParameter['subdomain'] = subdomain;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets an organization by id
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGetById: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('organizationsGetById', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates an organization
         * @param {string} organizationId
         * @param {OrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdate: (organizationId, organization, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('organizationsUpdate', 'organizationId', organizationId);
            // verify required parameter 'organization' is not null or undefined
            (0, common_1.assertParamExists)('organizationsUpdate', 'organization', organization);
            const localVarPath = `/organizations/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organization, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of permission groups by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGroupsGet: (organizationId, limit, skip, building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('permissionGroupsGet', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/permission_groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/pin_types?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a pin type by id in a building
         * @param {string} buildingId
         * @param {string} pinTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetById: (buildingId, pinTypeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesGetById', 'buildingId', buildingId);
            // verify required parameter 'pinTypeId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesGetById', 'pinTypeId', pinTypeId);
            const localVarPath = `/buildings/{buildingId}/pin_types/{pinTypeId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"pinTypeId"}}`, encodeURIComponent(String(pinTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization: (organizationId, limit, skip, building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('pinTypesGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/pin_types`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the report content for a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [id]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [values]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportBlockContent: (organizationId, reportBlockId, limit, skip, sort, id, building, pinType, name, address, values, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('previewReportBlockContent', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('previewReportBlockContent', 'reportBlockId', reportBlockId);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}/preview_report_content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (values !== undefined) {
                localVarQueryParameter['values'] = values;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/third_party/procore/my_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProjectsByCompany', 'companyId', companyId);
            const localVarPath = `/third_party/procore/my_companies/{companyId}/projects`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy: (endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'endpoint' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProxy', 'endpoint', endpoint);
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreGetProxy', 'companyId', companyId);
            const localVarPath = `/third_party/procore/proxy/{endpoint}`
                .replace(`{${"endpoint"}}`, encodeURIComponent(String(endpoint)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (filterType !== undefined) {
                localVarQueryParameter['filter_type'] = filterType;
            }
            if (drawingAreaId !== undefined) {
                localVarQueryParameter['drawing_area_id'] = drawingAreaId;
            }
            if (drawingDisciplineId !== undefined) {
                localVarQueryParameter['drawing_discipline_id'] = drawingDisciplineId;
            }
            if (drawingSetId !== undefined) {
                localVarQueryParameter['drawing_set_id'] = drawingSetId;
            }
            if (filtersSpecificationSectionId !== undefined) {
                localVarQueryParameter['filters[specification_section_id]'] = filtersSpecificationSectionId;
            }
            if (filtersStatusId !== undefined) {
                localVarQueryParameter['filters[status_id]'] = filtersStatusId;
            }
            if (filtersDocumentType !== undefined) {
                localVarQueryParameter['filters[document_type]'] = filtersDocumentType;
            }
            if (filtersFolderId !== undefined) {
                localVarQueryParameter['filters[folder_id]'] = filtersFolderId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled: (companyId, projectId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            (0, common_1.assertParamExists)('procoreIsAppInstalled', 'companyId', companyId);
            const localVarPath = `/third_party/procore/is_app_installed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth: (redirectUrl, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'redirectUrl' is not null or undefined
            (0, common_1.assertParamExists)('procoreOauth', 'redirectUrl', redirectUrl);
            const localVarPath = `/third_party/procore/oauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirect_url'] = redirectUrl;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles: (buildingId, organizationId, procorePullFilesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'buildingId', buildingId);
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'organizationId', organizationId);
            // verify required parameter 'procorePullFilesRequest' is not null or undefined
            (0, common_1.assertParamExists)('procorePullFiles', 'procorePullFilesRequest', procorePullFilesRequest);
            const localVarPath = `/third_party/procore/{organizationId}/pull/{buildingId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(procorePullFilesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report block content by report block id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentGetById: (organizationId, reportBlockId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlockContentGetById', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlockContentGetById', 'reportBlockId', reportBlockId);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report block content
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlockContentUpdateRequest} reportBlockContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentUpdate: (organizationId, reportBlockId, reportBlockContent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlockContentUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlockContentUpdate', 'reportBlockId', reportBlockId);
            // verify required parameter 'reportBlockContent' is not null or undefined
            (0, common_1.assertParamExists)('reportBlockContentUpdate', 'reportBlockContent', reportBlockContent);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportBlockContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksDelete: (organizationId, reportBlockId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksDelete', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksDelete', 'reportBlockId', reportBlockId);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report block by its id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetById: (organizationId, reportBlockId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksGetById', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksGetById', 'reportBlockId', reportBlockId);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of report blocks by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {'asset' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetByOrganization: (organizationId, sort, context, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/report_blocks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlocksUpdateRequest} reportBlock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksUpdate: (organizationId, reportBlockId, reportBlock, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportBlockId' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksUpdate', 'reportBlockId', reportBlockId);
            // verify required parameter 'reportBlock' is not null or undefined
            (0, common_1.assertParamExists)('reportBlocksUpdate', 'reportBlock', reportBlock);
            const localVarPath = `/organizations/{organizationId}/report_blocks/{reportBlockId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportBlockId"}}`, encodeURIComponent(String(reportBlockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportBlock, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentGetById', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentGetById', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate: (organizationId, reportId, reportContent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'reportId', reportId);
            // verify required parameter 'reportContent' is not null or undefined
            (0, common_1.assertParamExists)('reportContentUpdate', 'reportContent', reportContent);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new report footer or header
         * @param {string} organizationId
         * @param {ReportHeadersAndFootersCreateRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersCreate: (organizationId, postBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersCreate', 'organizationId', organizationId);
            // verify required parameter 'postBody' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersCreate', 'postBody', postBody);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report header/footer by id
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetById: (organizationId, reportHeaderFooterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersGetById', 'organizationId', organizationId);
            // verify required parameter 'reportHeaderFooterId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersGetById', 'reportHeaderFooterId', reportHeaderFooterId);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers/{reportHeaderFooterId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportHeaderFooterId"}}`, encodeURIComponent(String(reportHeaderFooterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report footers by their report id
         * @param {string} organizationId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetByOrganization: (organizationId, report, reportTemplate, type, showPageNumbers, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (report !== undefined) {
                localVarQueryParameter['report'] = report;
            }
            if (reportTemplate !== undefined) {
                localVarQueryParameter['report_template'] = reportTemplate;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (showPageNumbers !== undefined) {
                localVarQueryParameter['show_page_numbers'] = showPageNumbers;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a content of the report header/footers
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetContent: (organizationId, reportHeaderFooterId, report, reportTemplate, type, showPageNumbers, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersGetContent', 'organizationId', organizationId);
            // verify required parameter 'reportHeaderFooterId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersGetContent', 'reportHeaderFooterId', reportHeaderFooterId);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers/{reportHeaderFooterId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportHeaderFooterId"}}`, encodeURIComponent(String(reportHeaderFooterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (report !== undefined) {
                localVarQueryParameter['report'] = report;
            }
            if (reportTemplate !== undefined) {
                localVarQueryParameter['report_template'] = reportTemplate;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (showPageNumbers !== undefined) {
                localVarQueryParameter['show_page_numbers'] = showPageNumbers;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUpdateRequest} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUpdate: (organizationId, reportHeaderFooterId, payload, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportHeaderFooterId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUpdate', 'reportHeaderFooterId', reportHeaderFooterId);
            // verify required parameter 'payload' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUpdate', 'payload', payload);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers/{reportHeaderFooterId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportHeaderFooterId"}}`, encodeURIComponent(String(reportHeaderFooterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(payload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Uploads content to the header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUploadContentRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUploadContent: (organizationId, reportHeaderFooterId, postBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUploadContent', 'organizationId', organizationId);
            // verify required parameter 'reportHeaderFooterId' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUploadContent', 'reportHeaderFooterId', reportHeaderFooterId);
            // verify required parameter 'postBody' is not null or undefined
            (0, common_1.assertParamExists)('reportHeadersAndFootersUploadContent', 'postBody', postBody);
            const localVarPath = `/organizations/{organizationId}/report_headers_footers/{reportHeaderFooterId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportHeaderFooterId"}}`, encodeURIComponent(String(reportHeaderFooterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report template content by id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentGetById: (organizationId, reportTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplateContentGetById', 'organizationId', organizationId);
            // verify required parameter 'reportTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplateContentGetById', 'reportTemplateId', reportTemplateId);
            const localVarPath = `/organizations/{organizationId}/report_templates/{reportTemplateId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportTemplateId"}}`, encodeURIComponent(String(reportTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report template\'s content
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportContentUpdateRequest} reportTemplateContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentUpdate: (organizationId, reportTemplateId, reportTemplateContent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplateContentUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplateContentUpdate', 'reportTemplateId', reportTemplateId);
            // verify required parameter 'reportTemplateContent' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplateContentUpdate', 'reportTemplateContent', reportTemplateContent);
            const localVarPath = `/organizations/{organizationId}/report_templates/{reportTemplateId}/content`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportTemplateId"}}`, encodeURIComponent(String(reportTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportTemplateContent, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many report templates are in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCount: (organizationId, name, context, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/report_templates?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new report template
         * @param {string} organizationId
         * @param {ReportTemplatesCreateRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCreate: (organizationId, reportTemplate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesCreate', 'organizationId', organizationId);
            // verify required parameter 'reportTemplate' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesCreate', 'reportTemplate', reportTemplate);
            const localVarPath = `/organizations/{organizationId}/report_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportTemplate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesDelete: (organizationId, reportTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesDelete', 'organizationId', organizationId);
            // verify required parameter 'reportTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesDelete', 'reportTemplateId', reportTemplateId);
            const localVarPath = `/organizations/{organizationId}/report_templates/{reportTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportTemplateId"}}`, encodeURIComponent(String(reportTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report template by its id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetById: (organizationId, reportTemplateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesGetById', 'organizationId', organizationId);
            // verify required parameter 'reportTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesGetById', 'reportTemplateId', reportTemplateId);
            const localVarPath = `/organizations/{organizationId}/report_templates/{reportTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportTemplateId"}}`, encodeURIComponent(String(reportTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of report templates by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetByOrganization: (organizationId, name, context, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/report_templates`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportTemplatesUpdateByIdRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesUpdateById: (organizationId, reportTemplateId, reportTemplate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesUpdateById', 'organizationId', organizationId);
            // verify required parameter 'reportTemplateId' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesUpdateById', 'reportTemplateId', reportTemplateId);
            // verify required parameter 'reportTemplate' is not null or undefined
            (0, common_1.assertParamExists)('reportTemplatesUpdateById', 'reportTemplate', reportTemplate);
            const localVarPath = `/organizations/{organizationId}/report_templates/{reportTemplateId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportTemplateId"}}`, encodeURIComponent(String(reportTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportTemplate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount: (organizationId, name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/reports?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate: (organizationId, report, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsCreate', 'organizationId', organizationId);
            // verify required parameter 'report' is not null or undefined
            (0, common_1.assertParamExists)('reportsCreate', 'report', report);
            const localVarPath = `/organizations/{organizationId}/reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsDelete', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsDelete', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById: (organizationId, reportId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetById', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetById', 'reportId', reportId);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization: (organizationId, name, sort, limit, skip, insensitive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/reports`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (insensitive !== undefined) {
                localVarQueryParameter['insensitive'] = insensitive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate: (organizationId, reportId, report, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'organizationId', organizationId);
            // verify required parameter 'reportId' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'reportId', reportId);
            // verify required parameter 'report' is not null or undefined
            (0, common_1.assertParamExists)('reportsUpdate', 'report', report);
            const localVarPath = `/organizations/{organizationId}/reports/{reportId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets a room at the building level
         * @param {string} buildingId
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomsGetById: (buildingId, roomId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('roomsGetById', 'buildingId', buildingId);
            // verify required parameter 'roomId' is not null or undefined
            (0, common_1.assertParamExists)('roomsGetById', 'roomId', roomId);
            const localVarPath = `/buildings/{buildingId}/rooms/{roomId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a saml config
         * @param {SamlConfigCreateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        samlConfigCreate: (samlConfig, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'samlConfig' is not null or undefined
            (0, common_1.assertParamExists)('samlConfigCreate', 'samlConfig', samlConfig);
            const localVarPath = `/admin/saml_configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(samlConfig, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Send an email to the provided email address
         * @param {SendEmailRequest} sendEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: (sendEmailRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sendEmailRequest' is not null or undefined
            (0, common_1.assertParamExists)('sendEmail', 'sendEmailRequest', sendEmailRequest);
            const localVarPath = `/notification/send_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendEmailRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Get the list of themes
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteAdminGetThemes: (limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding: (building, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'building' is not null or undefined
            (0, common_1.assertParamExists)('tagsGetByBuilding', 'building', building);
            const localVarPath = `/buildings/{building}/tags`
                .replace(`{${"building"}}`, encodeURIComponent(String(building)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateCustomerAccountOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerAccountOrchestration: (customerAccountId, orchestrationId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('updateCustomerAccountOrchestration', 'customerAccountId', customerAccountId);
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('updateCustomerAccountOrchestration', 'orchestrationId', orchestrationId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('updateCustomerAccountOrchestration', 'body', body);
            const localVarPath = `/customer_accounts/{customerAccountId}/orchestrations/{orchestrationId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Updates the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {UpdateOrganizationRequest} updateOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: (customerAccountId, organizationId, updateOrganizationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('updateOrganization', 'customerAccountId', customerAccountId);
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('updateOrganization', 'organizationId', organizationId);
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateOrganization', 'updateOrganizationRequest', updateOrganizationRequest);
            const localVarPath = `/customer_accounts/{customerAccountId}/organizations/{organizationId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateOrganizationRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Site Admin: Update a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteAdminOrchestration: (orchestrationId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orchestrationId' is not null or undefined
            (0, common_1.assertParamExists)('updateSiteAdminOrchestration', 'orchestrationId', orchestrationId);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('updateSiteAdminOrchestration', 'body', body);
            const localVarPath = `/admin/orchestrations/{orchestrationId}`
                .replace(`{${"orchestrationId"}}`, encodeURIComponent(String(orchestrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {UpdateThemeRequest} updateThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTheme: (customerAccountId, themeId, updateThemeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerAccountId' is not null or undefined
            (0, common_1.assertParamExists)('updateTheme', 'customerAccountId', customerAccountId);
            // verify required parameter 'themeId' is not null or undefined
            (0, common_1.assertParamExists)('updateTheme', 'themeId', themeId);
            // verify required parameter 'updateThemeRequest' is not null or undefined
            (0, common_1.assertParamExists)('updateTheme', 'updateThemeRequest', updateThemeRequest);
            const localVarPath = `/customer_accounts/{customerAccountId}/themes/{themeId}`
                .replace(`{${"customerAccountId"}}`, encodeURIComponent(String(customerAccountId)))
                .replace(`{${"themeId"}}`, encodeURIComponent(String(themeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateThemeRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a user at the org level
         * @param {string} organizationId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetById: (organizationId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('usersGetById', 'organizationId', organizationId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usersGetById', 'userId', userId);
            const localVarPath = `/organizations/{organizationId}/users/{userId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets users in the orgainization
         * @param {string} organizationId
         * @param {string} [deactivateDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [email]
         * @param {string} [identity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization: (organizationId, deactivateDate, limit, skip, email, identity, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('usersGetByOrganization', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/users`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (deactivateDate !== undefined) {
                localVarQueryParameter['deactivate_date'] = (deactivateDate instanceof Date) ?
                    deactivateDate.toISOString() :
                    deactivateDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (identity !== undefined) {
                localVarQueryParameter['identity'] = identity;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetMyUser: (organizationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('usersGetMyUser', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/user`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {string} [modifiedAt]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets: (orgId, decommissioned, insensitive, id, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, modifiedAt, hasAttachments, values, sort, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('webGetAssets', 'orgId', orgId);
            const localVarPath = `/organizations/{orgId}/web/assets`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (insensitive !== undefined) {
                localVarQueryParameter['insensitive'] = insensitive;
            }
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (pinTypeName !== undefined) {
                localVarQueryParameter['pinType.name'] = pinTypeName;
            }
            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }
            if (roomNumber !== undefined) {
                localVarQueryParameter['room.number'] = roomNumber;
            }
            if (roomName !== undefined) {
                localVarQueryParameter['room.name'] = roomName;
            }
            if (conditionConditionRating !== undefined) {
                localVarQueryParameter['condition.condition_rating'] = conditionConditionRating;
            }
            if (costlinesTotalCostWithAdjustments !== undefined) {
                localVarQueryParameter['costlines.total_cost_with_adjustments'] = costlinesTotalCostWithAdjustments;
            }
            if (installationDate !== undefined) {
                localVarQueryParameter['installation_date'] = installationDate;
            }
            if (modifiedAt !== undefined) {
                localVarQueryParameter['modifiedAt'] = modifiedAt;
            }
            if (hasAttachments !== undefined) {
                localVarQueryParameter['has_attachments'] = hasAttachments;
            }
            if (values !== undefined) {
                localVarQueryParameter['values'] = values;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssetsCount: (orgId, sort, decommissioned, insensitive, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, hasAttachments, values, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orgId' is not null or undefined
            (0, common_1.assertParamExists)('webGetAssetsCount', 'orgId', orgId);
            const localVarPath = `/organizations/{orgId}/web/assets?count=true`
                .replace(`{${"orgId"}}`, encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (insensitive !== undefined) {
                localVarQueryParameter['insensitive'] = insensitive;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (pinTypeName !== undefined) {
                localVarQueryParameter['pinType.name'] = pinTypeName;
            }
            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }
            if (roomNumber !== undefined) {
                localVarQueryParameter['room.number'] = roomNumber;
            }
            if (roomName !== undefined) {
                localVarQueryParameter['room.name'] = roomName;
            }
            if (conditionConditionRating !== undefined) {
                localVarQueryParameter['condition.condition_rating'] = conditionConditionRating;
            }
            if (costlinesTotalCostWithAdjustments !== undefined) {
                localVarQueryParameter['costlines.total_cost_with_adjustments'] = costlinesTotalCostWithAdjustments;
            }
            if (installationDate !== undefined) {
                localVarQueryParameter['installation_date'] = installationDate;
            }
            if (hasAttachments !== undefined) {
                localVarQueryParameter['has_attachments'] = hasAttachments;
            }
            if (values !== undefined) {
                localVarQueryParameter['values'] = values;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of buildings catered soley to the web front-end
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildings: (organizationId, sort, limit, skip, id, name, address, city, state, postalCode, customFieldValues, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetBuildings', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/buildings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }
            if (customFieldValues !== undefined) {
                localVarQueryParameter['custom_field_values'] = customFieldValues;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * BFF Route for web-client buildings count
         * @param {string} organizationId
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildingsCount: (organizationId, id, name, address, city, state, postalCode, customFieldValues, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetBuildingsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/buildings?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (id !== undefined) {
                localVarQueryParameter['_id'] = id;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (postalCode !== undefined) {
                localVarQueryParameter['postal_code'] = postalCode;
            }
            if (customFieldValues !== undefined) {
                localVarQueryParameter['custom_field_values'] = customFieldValues;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklists: (organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetChecklists', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/checklists`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            if (inspectionProgram !== undefined) {
                localVarQueryParameter['inspection_program'] = inspectionProgram;
            }
            if (inspectionProgramName !== undefined) {
                localVarQueryParameter['inspection_program.name'] = inspectionProgramName;
            }
            if (inspectionProgramPriority !== undefined) {
                localVarQueryParameter['inspection_program.priority'] = inspectionProgramPriority;
            }
            if (inspectionProgramNumber !== undefined) {
                localVarQueryParameter['inspection_program.number'] = inspectionProgramNumber;
            }
            if (inspectionProgramStatus !== undefined) {
                localVarQueryParameter['inspection_program.status'] = inspectionProgramStatus;
            }
            if (inspection !== undefined) {
                localVarQueryParameter['inspection'] = inspection;
            }
            if (inspectionStartDate !== undefined) {
                localVarQueryParameter['inspection.start_date'] = inspectionStartDate;
            }
            if (inspectionDueDate !== undefined) {
                localVarQueryParameter['inspection.due_date'] = inspectionDueDate;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (checklistTemplateName !== undefined) {
                localVarQueryParameter['checklist_template.name'] = checklistTemplateName;
            }
            if (completedUserDisplayName !== undefined) {
                localVarQueryParameter['completed_user.display_name'] = completedUserDisplayName;
            }
            if (completedDate !== undefined) {
                localVarQueryParameter['completed_date'] = completedDate;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinTypeName !== undefined) {
                localVarQueryParameter['pin_type.name'] = pinTypeName;
            }
            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }
            if (roomNumber !== undefined) {
                localVarQueryParameter['room.number'] = roomNumber;
            }
            if (assetName !== undefined) {
                localVarQueryParameter['asset.name'] = assetName;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklistsCount: (organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetChecklistsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/checklists?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (complianceCode !== undefined) {
                localVarQueryParameter['compliance_code'] = complianceCode;
            }
            if (inspectionProgram !== undefined) {
                localVarQueryParameter['inspection_program'] = inspectionProgram;
            }
            if (inspectionProgramName !== undefined) {
                localVarQueryParameter['inspection_program.name'] = inspectionProgramName;
            }
            if (inspectionProgramPriority !== undefined) {
                localVarQueryParameter['inspection_program.priority'] = inspectionProgramPriority;
            }
            if (inspectionProgramNumber !== undefined) {
                localVarQueryParameter['inspection_program.number'] = inspectionProgramNumber;
            }
            if (inspectionProgramStatus !== undefined) {
                localVarQueryParameter['inspection_program.status'] = inspectionProgramStatus;
            }
            if (inspection !== undefined) {
                localVarQueryParameter['inspection'] = inspection;
            }
            if (inspectionStartDate !== undefined) {
                localVarQueryParameter['inspection.start_date'] = inspectionStartDate;
            }
            if (inspectionDueDate !== undefined) {
                localVarQueryParameter['inspection.due_date'] = inspectionDueDate;
            }
            if (checklistTemplate !== undefined) {
                localVarQueryParameter['checklist_template'] = checklistTemplate;
            }
            if (checklistTemplateName !== undefined) {
                localVarQueryParameter['checklist_template.name'] = checklistTemplateName;
            }
            if (completedUserDisplayName !== undefined) {
                localVarQueryParameter['completed_user.display_name'] = completedUserDisplayName;
            }
            if (completedDate !== undefined) {
                localVarQueryParameter['completed_date'] = completedDate;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinTypeName !== undefined) {
                localVarQueryParameter['pin_type.name'] = pinTypeName;
            }
            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }
            if (roomNumber !== undefined) {
                localVarQueryParameter['room.number'] = roomNumber;
            }
            if (assetName !== undefined) {
                localVarQueryParameter['asset.name'] = assetName;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of custom field associations for the given organization including custom field definitions and custom field enum values
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldAssociations: (organizationId, linkedEntityType, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetCustomFieldAssociations', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/custom_field_associations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (linkedEntityType !== undefined) {
                localVarQueryParameter['linked_entity_type'] = linkedEntityType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of custom field definitions for the given organization including custom field associations
         * @param {string} organizationId
         * @param {string} [dataType]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldDefinitions: (organizationId, dataType, name, limit, skip, sort, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetCustomFieldDefinitions', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/custom_field_definitions`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (dataType !== undefined) {
                localVarQueryParameter['data_type'] = dataType;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFields: (organizationId, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetFields', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/fields`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFieldsCount: (organizationId, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetFieldsCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/fields?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of pin type names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPinTypeNames: (organizationId, limit, skip, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetPinTypeNames', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/pin_type_names`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssetCount: (organizationId, name, building, pinType, decommissioned, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetReportBlockAssetCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/report_block_assets?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of assets catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssets: (organizationId, name, building, pinType, limit, skip, sort, decommissioned, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetReportBlockAssets', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/report_block_assets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildingCount: (organizationId, name, building, pinType, decommissioned, address, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetReportBlockBuildingCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/report_block_buildings?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (decommissioned !== undefined) {
                localVarQueryParameter['decommissioned'] = decommissioned;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the list of buildings catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildings: (organizationId, name, building, pinType, limit, skip, sort, address, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetReportBlockBuildings', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/report_block_buildings`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (building !== undefined) {
                localVarQueryParameter['building'] = building;
            }
            if (pinType !== undefined) {
                localVarQueryParameter['pinType'] = pinType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetWorkOrders: (organizationId, limit, skip, sortBy, startDate, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('webGetWorkOrders', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/work_orders`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGet: (buildingId, limit, skip, sortBy, startDate, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('workOrdersGet', 'buildingId', buildingId);
            const localVarPath = `/buildings/{buildingId}/tasks`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetById: (buildingId, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'buildingId' is not null or undefined
            (0, common_1.assertParamExists)('workOrdersGetById', 'buildingId', buildingId);
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('workOrdersGetById', 'taskId', taskId);
            const localVarPath = `/buildings/{buildingId}/tasks/{taskId}`
                .replace(`{${"buildingId"}}`, encodeURIComponent(String(buildingId)))
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the count of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetCount: (organizationId, limit, skip, sortBy, startDate, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationId' is not null or undefined
            (0, common_1.assertParamExists)('workOrdersGetCount', 'organizationId', organizationId);
            const localVarPath = `/organizations/{organizationId}/web/work_orders?count=true`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Creates an account
         * @param {AccountCreateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreate(customerAccount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accountCreate(customerAccount, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of customer accounts
         * @param {string} [name]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsCount(name, canCreateOrganizations, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomerAccountsCount(name, canCreateOrganizations, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of customer accounts
         * @param {string} [sort]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [modifyIdentities]
         * @param {string} [id]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGet(sort, name, limit, skip, modifyIdentities, id, canCreateOrganizations, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomerAccountsGet(sort, name, limit, skip, modifyIdentities, id, canCreateOrganizations, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGetById(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomerAccountsGetById(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {AdminCustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsUpdate(customerAccountId, customerAccount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomerAccountsUpdate(customerAccountId, customerAccount, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates an identity
         * @param {string} identityId
         * @param {AdminIdentitiesUpdateRequest} identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIdentitiesUpdate(identityId, identity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminIdentitiesUpdate(identityId, identity, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of organizations
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCount(name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrganizationsCount(name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates an org
         * @param {AdminOrganizationsCreateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCreate(organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrganizationsCreate(organization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of organizations
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsGet(sort, name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrganizationsGet(sort, name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates an org
         * @param {string} organizationId
         * @param {AdminOrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsUpdate(organizationId, organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrganizationsUpdate(organizationId, organization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a saml config
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigDelete(samlConfigId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSAMLConfigDelete(samlConfigId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a saml config by id
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigGetById(samlConfigId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSAMLConfigGetById(samlConfigId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a saml config
         * @param {string} samlConfigId
         * @param {AdminSAMLConfigUpdateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigUpdate(samlConfigId, samlConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSAMLConfigUpdate(samlConfigId, samlConfig, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of saml configs
         * @param {string} [sort]
         * @param {string} [customerAccount]
         * @param {string} [domain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigsGet(sort, customerAccount, domain, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSAMLConfigsGet(sort, customerAccount, domain, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount(organizationId, decommissioned, name, building, pinType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetsCount(organizationId, decommissioned, name, building, pinType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates an asset
         * @param {string} buildingId
         * @param {AssetsCreateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCreate(buildingId, asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetsCreate(buildingId, asset, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetById(buildingId, assetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetsGetById(buildingId, assetId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {AssetsUpdateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdate(buildingId, assetId, asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assetsUpdate(buildingId, assetId, asset, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount(building, linksEntityId, linksEntityType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsCount(building, linksEntityId, linksEntityType, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate(building, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsCreate(building, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding(building, linksEntityId, linksEntityType, deleteDate, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsGetByBuilding(building, linksEntityId, linksEntityType, deleteDate, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get attachments by organization, entity id, and entity type
         * @param {string} organization
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByOrganization(organization, linksEntityId, linksEntityType, deleteDate, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsGetByOrganization(organization, linksEntityId, linksEntityType, deleteDate, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate(buildingId, attachmentId, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachmentsUpdate(buildingId, attachmentId, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Federate an account
         * @param {AuthFederateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFederate(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authFederate(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Requests an email to reset password
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authForgotPassword(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authForgotPassword(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Login to a profile
         * @param {AuthPasswordLoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordLogin(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authPasswordLogin(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Registers a user under a customer account
         * @param {AuthRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegister(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authRegister(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Sends a verfication email to a newly created account
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendValidationEmail(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authSendValidationEmail(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a floor within a building
         * @param {string} buildingId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingLevelsGetById(buildingId, levelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingLevelsGetById(buildingId, levelId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsCount(organizationId, name, address, city, state, postalCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingsCount(organizationId, name, address, city, state, postalCode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetById(organizationId, buildingId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingsGetById(organizationId, buildingId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization(organizationId, sort, limit, skip, name, address, city, state, postalCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingsGetByOrganization(organizationId, sort, limit, skip, name, address, city, state, postalCode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {BuildingsUpdateRequest} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsUpdate(organizationId, buildingId, building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.buildingsUpdate(organizationId, buildingId, building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelImport(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet(catalogId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogGet(catalogId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemGet(catalogId, itemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemGet(catalogId, itemId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate(catalogId, catalogItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsCreate(catalogId, catalogItem, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes an item from a catalog
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsDelete(catalogId, itemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsDelete(catalogId, itemId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate(catalogId, itemId, catalogItem, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogItemsUpdate(catalogId, itemId, catalogItem, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate(catalogId, catalog, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogUpdate(catalogId, catalog, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount(name, modifiedDateMs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsCount(name, modifiedDateMs, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate(catalog, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsCreate(catalog, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet(name, modifiedDateMs, limit, sort, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.catalogsGet(name, modifiedDateMs, limit, sort, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of checklist templates for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [complianceCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGet(organizationId, limit, skip, sortBy, status, id, name, complianceCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checklistTemplatesGet(organizationId, limit, skip, sortBy, status, id, name, complianceCode, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a checklist template in the given organization
         * @param {string} organizationId
         * @param {string} checklistTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGetById(organizationId, checklistTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checklistTemplatesGetById(organizationId, checklistTemplateId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsCount(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checklistsCount(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsGet(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, checklistTemplate, completedDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checklistsGet(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, checklistTemplate, completedDate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the stats of checklists for the given organization
         * @param {string} organizationId
         * @param {string} groupField
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsStatsGroup(organizationId, groupField, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checklistsStatsGroup(organizationId, groupField, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ckeditorGetToken(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Generate a confirmation code to login
         * @param {ConfirmationCodeCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationCodeCreate(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmationCodeCreate(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get cost data for the provided line number and catalog in the building\'s catalog location and release
         * @param {string} buildingId
         * @param {CostDataCatalog} catalogType
         * @param {string} lineNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costDataGetByBuilding(buildingId, catalogType, lineNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.costDataGetByBuilding(buildingId, catalogType, lineNumber, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of cost lines by building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByBuilding(buildingId, limit, skip, asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.costLinesGetByBuilding(buildingId, limit, skip, asset, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a cost line by id in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetById(buildingId, costLineId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.costLinesGetById(buildingId, costLineId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of cost lines by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByOrganization(organizationId, limit, skip, building, asset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.costLinesGetByOrganization(organizationId, limit, skip, building, asset, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a cost line in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {CostLinesUpdateRequest} costLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesUpdate(buildingId, costLineId, costLine, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.costLinesUpdate(buildingId, costLineId, costLine, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizations(customerAccountId, name, subdomainKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.countOrganizations(customerAccountId, name, subdomainKey, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create a new orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {CreateOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestration(customerAccountId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCustomerAccountOrchestration(customerAccountId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {CreateStepsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates an organizations within a customer account
         * @param {string} customerAccountId
         * @param {CreateOrganizationRequest} createOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(customerAccountId, createOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOrganization(customerAccountId, createOrganizationRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Create a new orchestration
         * @param {CreateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestration(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSiteAdminOrchestration(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Create steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {Array<CreateStepRequest>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestrationSteps(orchestrationId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createSiteAdminOrchestrationSteps(orchestrationId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create a new theme for the customer account
         * @param {string} customerAccountId
         * @param {CreateThemeRequest} createThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTheme(customerAccountId, createThemeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTheme(customerAccountId, createThemeRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * creates a JWT for the email, code and customer account combination
         * @param {CreateTokenRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createToken(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationDelete(organizationId, customFieldAssociationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldAssociationDelete(organizationId, customFieldAssociationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationGet(organizationId, customFieldAssociationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldAssociationGet(organizationId, customFieldAssociationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the custom field association for the given organization
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {CustomFieldAssociationUpdateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationUpdate(organizationId, customFieldAssociationId, customFieldAssociation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldAssociationUpdate(organizationId, customFieldAssociationId, customFieldAssociation, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a custom field association
         * @param {string} organizationId
         * @param {CustomFieldAssociationsCreateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsCreate(organizationId, customFieldAssociation, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldAssociationsCreate(organizationId, customFieldAssociation, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of custom field associations for the given organization
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsGet(organizationId, linkedEntityType, customFieldDefinition, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldAssociationsGet(organizationId, linkedEntityType, customFieldDefinition, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionDelete(organizationId, customFieldDefinitionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldDefinitionDelete(organizationId, customFieldDefinitionId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionGet(organizationId, customFieldDefinitionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldDefinitionGet(organizationId, customFieldDefinitionId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the custom field definition for the given organization
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {CustomFieldDefinitionUpdateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionUpdate(organizationId, customFieldDefinitionId, customFieldDefinition, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldDefinitionUpdate(organizationId, customFieldDefinitionId, customFieldDefinition, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a custom field definition
         * @param {string} organizationId
         * @param {CustomFieldDefinitionsCreateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsCreate(organizationId, customFieldDefinition, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldDefinitionsCreate(organizationId, customFieldDefinition, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of custom field definitions for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsGet(organizationId, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldDefinitionsGet(organizationId, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueDelete(organizationId, customFieldEnumValueId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValueDelete(organizationId, customFieldEnumValueId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueGet(organizationId, customFieldEnumValueId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValueGet(organizationId, customFieldEnumValueId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the custom field enum value for the given id
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {CustomFieldEnumValueUpdateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueUpdate(organizationId, customFieldEnumValueId, customFieldEnumValue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValueUpdate(organizationId, customFieldEnumValueId, customFieldEnumValue, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Count the custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCount(organizationId, customFieldDefinition, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValuesCount(organizationId, customFieldDefinition, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a custom field enum value
         * @param {string} organizationId
         * @param {CustomFieldEnumValuesCreateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCreate(organizationId, customFieldEnumValue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValuesCreate(organizationId, customFieldEnumValue, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesGet(organizationId, customFieldDefinition, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldEnumValuesGet(organizationId, customFieldDefinition, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the custom field values for the given organization on organizations only
         * @param {string} organizationId
         * @param {string} [linkedEntityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesGet(organizationId, linkedEntityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldValuesGet(organizationId, linkedEntityId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update the given custom field value for the given organization
         * @param {string} organizationId
         * @param {string} customFieldValueId
         * @param {CustomFieldValuesUpdateRequest} customFieldValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesUpdate(organizationId, customFieldValueId, customFieldValue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customFieldValuesUpdate(organizationId, customFieldValueId, customFieldValue, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionDelete(customerAccountId, defaultPermissionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionDelete(customerAccountId, defaultPermissionId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionGet(customerAccountId, defaultPermissionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionGet(customerAccountId, defaultPermissionId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionUpdate(customerAccountId, defaultPermissionId, defaultPermission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionUpdate(customerAccountId, defaultPermissionId, defaultPermission, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of default permissions for a customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCount(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionsCount(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCreate(customerAccountId, defaultPermission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionsCreate(customerAccountId, defaultPermission, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [externalGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsGet(customerAccountId, limit, skip, sort, name, externalGroup, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsDefaultPermissionsGet(customerAccountId, limit, skip, sort, name, externalGroup, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsGetById(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsGetById(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {CustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsUpdate(customerAccountId, customerAccount, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customerAccountsUpdate(customerAccountId, customerAccount, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(customerAccountId, organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteOrganization(customerAccountId, organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Delete a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTheme(customerAccountId, themeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTheme(customerAccountId, themeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload(building, file, attachment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.documentsUpload(building, file, attachment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of field groups by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldGroupsGetByOrganization(organizationId, name, context, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fieldGroupsGetByOrganization(organizationId, name, context, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate(organization, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fileCreate(organization, file, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get file
         * @param {string} organization
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGet(organization, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fileGet(organization, file, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload(organization, file, fileAction, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.filesCompleteUpload(organization, file, fileAction, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get file
         * @param {string} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet(organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.filesGet(organization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.flagsGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the active theme for the customer account (if there is one)
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTheme(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveTheme(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the importable fields for assets
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetImportFields(targetId, updatable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssetImportFields(targetId, updatable, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the authentication methods allowed by the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthnMethods(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthnMethods(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the importable fields for buildings
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingImportFields(targetId, updatable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBuildingImportFields(targetId, updatable, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult(importId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCSVResult(importId, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestration(customerAccountId, orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccountOrchestration(customerAccountId, orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get steps results as CSV for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsCSV(customerAccountId, orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccountOrchestrationStepsCSV(customerAccountId, orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get steps statistics for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsStats(customerAccountId, orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccountOrchestrationStepsStats(customerAccountId, orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get orchestrations for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrations(customerAccountId, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccountOrchestrations(customerAccountId, type, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get customer accounts that belong to email and code combination
         * @param {GetCustomerAccountsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccounts(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCustomerAccounts(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets an organization within a customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationGetById(customerAccountId, organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizationGetById(customerAccountId, organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(customerAccountId, name, subdomainKey, sort, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrganizations(customerAccountId, name, subdomainKey, sort, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows(importId, status, limit, sort, startKey, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRows(importId, status, limit, sort, startKey, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestration(orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteAdminOrchestration(orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {number} [limit] Maximum number of steps to return
         * @param {string} [startKey] Pagination start key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationSteps(orchestrationId, status, limit, startKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteAdminOrchestrationSteps(orchestrationId, status, limit, startKey, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get steps results as CSV for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsCSV(orchestrationId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteAdminOrchestrationStepsCSV(orchestrationId, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get steps statistics for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsStats(orchestrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteAdminOrchestrationStepsStats(orchestrationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get orchestrations
         * @param {OrchestrationTargetEntity} [targetEntity] Filter orchestrations by target entity
         * @param {string} [targetId] Filter orchestrations by target ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrations(targetEntity, targetId, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSiteAdminOrchestrations(targetEntity, targetId, type, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheme(customerAccountId, themeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTheme(customerAccountId, themeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of themes for the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemes(customerAccountId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getThemes(customerAccountId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCountUsers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.identityCountUsers(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a JWT for the email and password combination
         * @param {AdminOrganizationsUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCreateToken(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.identityCreateToken(body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets data for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.identityGet(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {string} [sisenseRole]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGetUsers(sisenseRole, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.identityGetUsers(sisenseRole, limit, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV(targetId, targetEntity, importEntity, files, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importCSV(targetId, targetEntity, importEntity, files, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Checks the row actions stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowActionsStats(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importRowActionsStats(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.importRowsStats(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [number]
         * @param {string} [name]
         * @param {string} [priority]
         * @param {string} [checklistTemplate]
         * @param {string} [assignees]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGet(organizationId, limit, skip, sortBy, status, number, name, priority, checklistTemplate, assignees, building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.inspectionProgramsGet(organizationId, limit, skip, sortBy, status, number, name, priority, checklistTemplate, assignees, building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGetCount(organizationId, limit, skip, sortBy, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.inspectionProgramsGetCount(organizationId, limit, skip, sortBy, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets all floors within an organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsByOrganization(organizationId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.levelsByOrganization(organizationId, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a floor within an organization
         * @param {string} organizationId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsGetById(organizationId, levelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.levelsGetById(organizationId, levelId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Cancel the export process for the given exportId
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCancel(exportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myExportsCancel(exportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Process the given export request
         * @param {MyExportsCreateRequest} [myExportsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCreate(myExportsCreateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myExportsCreate(myExportsCreateRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the export by its id
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsGet(exportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myExportsGet(exportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of exports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [exportEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsList(limit, startKey, status, targetEntity, targetId, exportEntity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myExportsList(limit, startKey, status, targetEntity, targetId, exportEntity, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the import by its id
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsGet(importId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myImportsGet(importId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of imports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [importEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsList(limit, startKey, status, targetEntity, targetId, importEntity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.myImportsList(limit, startKey, status, targetEntity, targetId, importEntity, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the count of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCount(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsCount(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsDelete(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet(subdomain, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsGet(subdomain, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets an organization by id
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGetById(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsGetById(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates an organization
         * @param {string} organizationId
         * @param {OrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdate(organizationId, organization, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.organizationsUpdate(organizationId, organization, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of permission groups by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGroupsGet(organizationId, limit, skip, building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.permissionGroupsGet(organizationId, limit, skip, building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pinTypesCount(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a pin type by id in a building
         * @param {string} buildingId
         * @param {string} pinTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetById(buildingId, pinTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pinTypesGetById(buildingId, pinTypeId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization(organizationId, limit, skip, building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pinTypesGetByOrganization(organizationId, limit, skip, building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the report content for a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [id]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [values]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportBlockContent(organizationId, reportBlockId, limit, skip, sort, id, building, pinType, name, address, values, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.previewReportBlockContent(organizationId, reportBlockId, limit, skip, sort, id, building, pinType, name, address, values, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetMyCompanies(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetProjectsByCompany(companyId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled(companyId, projectId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreIsAppInstalled(companyId, projectId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth(redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procoreOauth(redirectUrl, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report block content by report block id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentGetById(organizationId, reportBlockId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlockContentGetById(organizationId, reportBlockId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report block content
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlockContentUpdateRequest} reportBlockContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentUpdate(organizationId, reportBlockId, reportBlockContent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlockContentUpdate(organizationId, reportBlockId, reportBlockContent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksDelete(organizationId, reportBlockId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlocksDelete(organizationId, reportBlockId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report block by its id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetById(organizationId, reportBlockId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlocksGetById(organizationId, reportBlockId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of report blocks by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {'asset' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetByOrganization(organizationId, sort, context, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlocksGetByOrganization(organizationId, sort, context, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlocksUpdateRequest} reportBlock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksUpdate(organizationId, reportBlockId, reportBlock, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBlocksUpdate(organizationId, reportBlockId, reportBlock, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportContentGetById(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate(organizationId, reportId, reportContent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportContentUpdate(organizationId, reportId, reportContent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new report footer or header
         * @param {string} organizationId
         * @param {ReportHeadersAndFootersCreateRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersCreate(organizationId, postBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersCreate(organizationId, postBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report header/footer by id
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetById(organizationId, reportHeaderFooterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersGetById(organizationId, reportHeaderFooterId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report footers by their report id
         * @param {string} organizationId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetByOrganization(organizationId, report, reportTemplate, type, showPageNumbers, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersGetByOrganization(organizationId, report, reportTemplate, type, showPageNumbers, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a content of the report header/footers
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetContent(organizationId, reportHeaderFooterId, report, reportTemplate, type, showPageNumbers, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersGetContent(organizationId, reportHeaderFooterId, report, reportTemplate, type, showPageNumbers, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUpdateRequest} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUpdate(organizationId, reportHeaderFooterId, payload, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersUpdate(organizationId, reportHeaderFooterId, payload, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Uploads content to the header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUploadContentRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUploadContent(organizationId, reportHeaderFooterId, postBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportHeadersAndFootersUploadContent(organizationId, reportHeaderFooterId, postBody, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report template content by id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentGetById(organizationId, reportTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplateContentGetById(organizationId, reportTemplateId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report template\'s content
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportContentUpdateRequest} reportTemplateContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentUpdate(organizationId, reportTemplateId, reportTemplateContent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplateContentUpdate(organizationId, reportTemplateId, reportTemplateContent, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many report templates are in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCount(organizationId, name, context, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesCount(organizationId, name, context, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new report template
         * @param {string} organizationId
         * @param {ReportTemplatesCreateRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCreate(organizationId, reportTemplate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesCreate(organizationId, reportTemplate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesDelete(organizationId, reportTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesDelete(organizationId, reportTemplateId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report template by its id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetById(organizationId, reportTemplateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesGetById(organizationId, reportTemplateId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of report templates by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetByOrganization(organizationId, name, context, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesGetByOrganization(organizationId, name, context, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportTemplatesUpdateByIdRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesUpdateById(organizationId, reportTemplateId, reportTemplate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTemplatesUpdateById(organizationId, reportTemplateId, reportTemplate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount(organizationId, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsCount(organizationId, name, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate(organizationId, report, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsCreate(organizationId, report, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsDelete(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById(organizationId, reportId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsGetById(organizationId, reportId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate(organizationId, reportId, report, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportsUpdate(organizationId, reportId, report, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets a room at the building level
         * @param {string} buildingId
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomsGetById(buildingId, roomId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.roomsGetById(buildingId, roomId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Creates a saml config
         * @param {SamlConfigCreateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        samlConfigCreate(samlConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.samlConfigCreate(samlConfig, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Send an email to the provided email address
         * @param {SendEmailRequest} sendEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(sendEmailRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendEmail(sendEmailRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Get the list of themes
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteAdminGetThemes(limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.siteAdminGetThemes(limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding(building, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.tagsGetByBuilding(building, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateCustomerAccountOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerAccountOrchestration(customerAccountId, orchestrationId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCustomerAccountOrchestration(customerAccountId, orchestrationId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Updates the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {UpdateOrganizationRequest} updateOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(customerAccountId, organizationId, updateOrganizationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateOrganization(customerAccountId, organizationId, updateOrganizationRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Site Admin: Update a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteAdminOrchestration(orchestrationId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateSiteAdminOrchestration(orchestrationId, body, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {UpdateThemeRequest} updateThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTheme(customerAccountId, themeId, updateThemeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTheme(customerAccountId, themeId, updateThemeRequest, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a user at the org level
         * @param {string} organizationId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetById(organizationId, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersGetById(organizationId, userId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets users in the orgainization
         * @param {string} organizationId
         * @param {string} [deactivateDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [email]
         * @param {string} [identity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization(organizationId, deactivateDate, limit, skip, email, identity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersGetByOrganization(organizationId, deactivateDate, limit, skip, email, identity, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetMyUser(organizationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersGetMyUser(organizationId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {string} [modifiedAt]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets(orgId, decommissioned, insensitive, id, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, modifiedAt, hasAttachments, values, sort, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetAssets(orgId, decommissioned, insensitive, id, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, modifiedAt, hasAttachments, values, sort, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssetsCount(orgId, sort, decommissioned, insensitive, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, hasAttachments, values, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetAssetsCount(orgId, sort, decommissioned, insensitive, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, hasAttachments, values, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of buildings catered soley to the web front-end
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildings(organizationId, sort, limit, skip, id, name, address, city, state, postalCode, customFieldValues, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetBuildings(organizationId, sort, limit, skip, id, name, address, city, state, postalCode, customFieldValues, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * BFF Route for web-client buildings count
         * @param {string} organizationId
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildingsCount(organizationId, id, name, address, city, state, postalCode, customFieldValues, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetBuildingsCount(organizationId, id, name, address, city, state, postalCode, customFieldValues, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklists(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetChecklists(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklistsCount(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetChecklistsCount(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of custom field associations for the given organization including custom field definitions and custom field enum values
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldAssociations(organizationId, linkedEntityType, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetCustomFieldAssociations(organizationId, linkedEntityType, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of custom field definitions for the given organization including custom field associations
         * @param {string} organizationId
         * @param {string} [dataType]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldDefinitions(organizationId, dataType, name, limit, skip, sort, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetCustomFieldDefinitions(organizationId, dataType, name, limit, skip, sort, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFields(organizationId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetFields(organizationId, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFieldsCount(organizationId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetFieldsCount(organizationId, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of pin type names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPinTypeNames(organizationId, limit, skip, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetPinTypeNames(organizationId, limit, skip, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssetCount(organizationId, name, building, pinType, decommissioned, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetReportBlockAssetCount(organizationId, name, building, pinType, decommissioned, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of assets catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssets(organizationId, name, building, pinType, limit, skip, sort, decommissioned, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetReportBlockAssets(organizationId, name, building, pinType, limit, skip, sort, decommissioned, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildingCount(organizationId, name, building, pinType, decommissioned, address, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetReportBlockBuildingCount(organizationId, name, building, pinType, decommissioned, address, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the list of buildings catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildings(organizationId, name, building, pinType, limit, skip, sort, address, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetReportBlockBuildings(organizationId, name, building, pinType, limit, skip, sort, address, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetWorkOrders(organizationId, limit, skip, sortBy, startDate, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.webGetWorkOrders(organizationId, limit, skip, sortBy, startDate, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGet(buildingId, limit, skip, sortBy, startDate, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workOrdersGet(buildingId, limit, skip, sortBy, startDate, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetById(buildingId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workOrdersGetById(buildingId, taskId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the count of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetCount(organizationId, limit, skip, sortBy, startDate, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.workOrdersGetCount(organizationId, limit, skip, sortBy, startDate, status, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Creates an account
         * @param {AccountCreateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountCreate(customerAccount, options) {
            return localVarFp.accountCreate(customerAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of customer accounts
         * @param {string} [name]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsCount(name, canCreateOrganizations, options) {
            return localVarFp.adminCustomerAccountsCount(name, canCreateOrganizations, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of customer accounts
         * @param {string} [sort]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [modifyIdentities]
         * @param {string} [id]
         * @param {boolean} [canCreateOrganizations]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGet(sort, name, limit, skip, modifyIdentities, id, canCreateOrganizations, options) {
            return localVarFp.adminCustomerAccountsGet(sort, name, limit, skip, modifyIdentities, id, canCreateOrganizations, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsGetById(customerAccountId, options) {
            return localVarFp.adminCustomerAccountsGetById(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {AdminCustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomerAccountsUpdate(customerAccountId, customerAccount, options) {
            return localVarFp.adminCustomerAccountsUpdate(customerAccountId, customerAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an identity
         * @param {string} identityId
         * @param {AdminIdentitiesUpdateRequest} identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminIdentitiesUpdate(identityId, identity, options) {
            return localVarFp.adminIdentitiesUpdate(identityId, identity, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of organizations
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCount(name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options) {
            return localVarFp.adminOrganizationsCount(name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an org
         * @param {AdminOrganizationsCreateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsCreate(organization, options) {
            return localVarFp.adminOrganizationsCreate(organization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of organizations
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [customerAccount]
         * @param {string} [deactivatedDate]
         * @param {boolean} [isDemo]
         * @param {string} [subdomain]
         * @param {string} [subdomainKey]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsGet(sort, name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options) {
            return localVarFp.adminOrganizationsGet(sort, name, customerAccount, deactivatedDate, isDemo, subdomain, subdomainKey, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an org
         * @param {string} organizationId
         * @param {AdminOrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrganizationsUpdate(organizationId, organization, options) {
            return localVarFp.adminOrganizationsUpdate(organizationId, organization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a saml config
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigDelete(samlConfigId, options) {
            return localVarFp.adminSAMLConfigDelete(samlConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a saml config by id
         * @param {string} samlConfigId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigGetById(samlConfigId, options) {
            return localVarFp.adminSAMLConfigGetById(samlConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a saml config
         * @param {string} samlConfigId
         * @param {AdminSAMLConfigUpdateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigUpdate(samlConfigId, samlConfig, options) {
            return localVarFp.adminSAMLConfigUpdate(samlConfigId, samlConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of saml configs
         * @param {string} [sort]
         * @param {string} [customerAccount]
         * @param {string} [domain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSAMLConfigsGet(sort, customerAccount, domain, limit, skip, options) {
            return localVarFp.adminSAMLConfigsGet(sort, customerAccount, domain, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {boolean} [decommissioned]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCount(organizationId, decommissioned, name, building, pinType, options) {
            return localVarFp.assetsCount(organizationId, decommissioned, name, building, pinType, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an asset
         * @param {string} buildingId
         * @param {AssetsCreateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsCreate(buildingId, asset, options) {
            return localVarFp.assetsCreate(buildingId, asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsGetById(buildingId, assetId, options) {
            return localVarFp.assetsGetById(buildingId, assetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an asset at the building level
         * @param {string} buildingId
         * @param {string} assetId
         * @param {AssetsUpdateRequest} asset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetsUpdate(buildingId, assetId, asset, options) {
            return localVarFp.assetsUpdate(buildingId, assetId, asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many attachments exists in the building
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCount(building, linksEntityId, linksEntityType, options) {
            return localVarFp.attachmentsCount(building, linksEntityId, linksEntityType, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new attachment
         * @param {string} building
         * @param {AttachmentsCreateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsCreate(building, attachment, options) {
            return localVarFp.attachmentsCreate(building, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get attachments by building, entity id, and entity type
         * @param {string} building
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByBuilding(building, linksEntityId, linksEntityType, deleteDate, limit, skip, options) {
            return localVarFp.attachmentsGetByBuilding(building, linksEntityId, linksEntityType, deleteDate, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Get attachments by organization, entity id, and entity type
         * @param {string} organization
         * @param {string} linksEntityId
         * @param {string} linksEntityType
         * @param {string} [deleteDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsGetByOrganization(organization, linksEntityId, linksEntityType, deleteDate, limit, skip, options) {
            return localVarFp.attachmentsGetByOrganization(organization, linksEntityId, linksEntityType, deleteDate, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a attachment
         * @param {string} buildingId
         * @param {string} attachmentId
         * @param {AttachmentsUpdateRequest} attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentsUpdate(buildingId, attachmentId, attachment, options) {
            return localVarFp.attachmentsUpdate(buildingId, attachmentId, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Federate an account
         * @param {AuthFederateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authFederate(body, options) {
            return localVarFp.authFederate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Requests an email to reset password
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authForgotPassword(body, options) {
            return localVarFp.authForgotPassword(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Login to a profile
         * @param {AuthPasswordLoginRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordLogin(body, options) {
            return localVarFp.authPasswordLogin(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers a user under a customer account
         * @param {AuthRegisterRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRegister(body, options) {
            return localVarFp.authRegister(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a verfication email to a newly created account
         * @param {AuthForgotPasswordRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendValidationEmail(body, options) {
            return localVarFp.authSendValidationEmail(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a floor within a building
         * @param {string} buildingId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingLevelsGetById(buildingId, levelId, options) {
            return localVarFp.buildingLevelsGetById(buildingId, levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsCount(organizationId, name, address, city, state, postalCode, options) {
            return localVarFp.buildingsCount(organizationId, name, address, city, state, postalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetById(organizationId, buildingId, options) {
            return localVarFp.buildingsGetById(organizationId, buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of buildings by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsGetByOrganization(organizationId, sort, limit, skip, name, address, city, state, postalCode, options) {
            return localVarFp.buildingsGetByOrganization(organizationId, sort, limit, skip, name, address, city, state, postalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a building within an organization
         * @param {string} organizationId
         * @param {string} buildingId
         * @param {BuildingsUpdateRequest} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildingsUpdate(organizationId, buildingId, building, options) {
            return localVarFp.buildingsUpdate(organizationId, buildingId, building, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the import process for the given importId
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelImport(importId, options) {
            return localVarFp.cancelImport(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets data from a catalog by its id
         * @param {string} catalogId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogGet(catalogId, options) {
            return localVarFp.catalogGet(catalogId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemGet(catalogId, itemId, options) {
            return localVarFp.catalogItemGet(catalogId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many catalog items exists
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return localVarFp.catalogItemsCount(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new catalog item
         * @param {string} catalogId
         * @param {CatalogItemsCreateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsCreate(catalogId, catalogItem, options) {
            return localVarFp.catalogItemsCreate(catalogId, catalogItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an item from a catalog
         * @param {string} catalogId
         * @param {string} itemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsDelete(catalogId, itemId, options) {
            return localVarFp.catalogItemsDelete(catalogId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of items of a catalog
         * @param {string} catalogId
         * @param {string} [itemId]
         * @param {string} [name]
         * @param {string} [description]
         * @param {string} [quantityUnit]
         * @param {number} [size]
         * @param {string} [sizeUnit]
         * @param {number} [frequency]
         * @param {number} [materialsUnitCostCents]
         * @param {number} [laborUnitCostCents]
         * @param {number} [equipmentUnitCostCents]
         * @param {number} [unitCostCents]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options) {
            return localVarFp.catalogItemsGet(catalogId, itemId, name, description, quantityUnit, size, sizeUnit, frequency, materialsUnitCostCents, laborUnitCostCents, equipmentUnitCostCents, unitCostCents, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a catalog item
         * @param {string} catalogId
         * @param {string} itemId
         * @param {CatalogItemsUpdateRequest} catalogItem
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogItemsUpdate(catalogId, itemId, catalogItem, options) {
            return localVarFp.catalogItemsUpdate(catalogId, itemId, catalogItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a catalog
         * @param {string} catalogId
         * @param {CatalogUpdateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogUpdate(catalogId, catalog, options) {
            return localVarFp.catalogUpdate(catalogId, catalog, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many catalogs exists
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCount(name, modifiedDateMs, options) {
            return localVarFp.catalogsCount(name, modifiedDateMs, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new catalog
         * @param {CatalogsCreateRequest} catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsCreate(catalog, options) {
            return localVarFp.catalogsCreate(catalog, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of Catalogs
         * @param {string} [name]
         * @param {string} [modifiedDateMs]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogsGet(name, modifiedDateMs, limit, sort, skip, options) {
            return localVarFp.catalogsGet(name, modifiedDateMs, limit, sort, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of checklist templates for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [complianceCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGet(organizationId, limit, skip, sortBy, status, id, name, complianceCode, options) {
            return localVarFp.checklistTemplatesGet(organizationId, limit, skip, sortBy, status, id, name, complianceCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a checklist template in the given organization
         * @param {string} organizationId
         * @param {string} checklistTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplatesGetById(organizationId, checklistTemplateId, options) {
            return localVarFp.checklistTemplatesGetById(organizationId, checklistTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsCount(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options) {
            return localVarFp.checklistsCount(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsGet(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, checklistTemplate, completedDate, options) {
            return localVarFp.checklistsGet(organizationId, limit, skip, sortBy, asset, building, status, complianceCode, checklistTemplate, completedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the stats of checklists for the given organization
         * @param {string} organizationId
         * @param {string} groupField
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [asset]
         * @param {string} [building]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgramId]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspectionId]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [completedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistsStatsGroup(organizationId, groupField, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options) {
            return localVarFp.checklistsStatsGroup(organizationId, groupField, limit, skip, sortBy, asset, building, status, complianceCode, inspectionProgramId, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspectionId, inspectionStartDate, inspectionDueDate, checklistTemplate, completedDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch token for CKEditor
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ckeditorGetToken(options) {
            return localVarFp.ckeditorGetToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a confirmation code to login
         * @param {ConfirmationCodeCreateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmationCodeCreate(body, options) {
            return localVarFp.confirmationCodeCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cost data for the provided line number and catalog in the building\'s catalog location and release
         * @param {string} buildingId
         * @param {CostDataCatalog} catalogType
         * @param {string} lineNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costDataGetByBuilding(buildingId, catalogType, lineNumber, options) {
            return localVarFp.costDataGetByBuilding(buildingId, catalogType, lineNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of cost lines by building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByBuilding(buildingId, limit, skip, asset, options) {
            return localVarFp.costLinesGetByBuilding(buildingId, limit, skip, asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a cost line by id in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetById(buildingId, costLineId, options) {
            return localVarFp.costLinesGetById(buildingId, costLineId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of cost lines by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {string} [asset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesGetByOrganization(organizationId, limit, skip, building, asset, options) {
            return localVarFp.costLinesGetByOrganization(organizationId, limit, skip, building, asset, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a cost line in a building
         * @param {string} buildingId
         * @param {string} costLineId
         * @param {CostLinesUpdateRequest} costLine
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        costLinesUpdate(buildingId, costLineId, costLine, options) {
            return localVarFp.costLinesUpdate(buildingId, costLineId, costLine, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOrganizations(customerAccountId, name, subdomainKey, options) {
            return localVarFp.countOrganizations(customerAccountId, name, subdomainKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {CreateOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestration(customerAccountId, body, options) {
            return localVarFp.createCustomerAccountOrchestration(customerAccountId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {CreateStepsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, body, options) {
            return localVarFp.createCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an organizations within a customer account
         * @param {string} customerAccountId
         * @param {CreateOrganizationRequest} createOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(customerAccountId, createOrganizationRequest, options) {
            return localVarFp.createOrganization(customerAccountId, createOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Create a new orchestration
         * @param {CreateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestration(body, options) {
            return localVarFp.createSiteAdminOrchestration(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Create steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {Array<CreateStepRequest>} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSiteAdminOrchestrationSteps(orchestrationId, body, options) {
            return localVarFp.createSiteAdminOrchestrationSteps(orchestrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new theme for the customer account
         * @param {string} customerAccountId
         * @param {CreateThemeRequest} createThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTheme(customerAccountId, createThemeRequest, options) {
            return localVarFp.createTheme(customerAccountId, createThemeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * creates a JWT for the email, code and customer account combination
         * @param {CreateTokenRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createToken(body, options) {
            return localVarFp.createToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationDelete(organizationId, customFieldAssociationId, options) {
            return localVarFp.customFieldAssociationDelete(organizationId, customFieldAssociationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom field association
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationGet(organizationId, customFieldAssociationId, options) {
            return localVarFp.customFieldAssociationGet(organizationId, customFieldAssociationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the custom field association for the given organization
         * @param {string} organizationId
         * @param {string} customFieldAssociationId
         * @param {CustomFieldAssociationUpdateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationUpdate(organizationId, customFieldAssociationId, customFieldAssociation, options) {
            return localVarFp.customFieldAssociationUpdate(organizationId, customFieldAssociationId, customFieldAssociation, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a custom field association
         * @param {string} organizationId
         * @param {CustomFieldAssociationsCreateRequest} customFieldAssociation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsCreate(organizationId, customFieldAssociation, options) {
            return localVarFp.customFieldAssociationsCreate(organizationId, customFieldAssociation, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of custom field associations for the given organization
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldAssociationsGet(organizationId, linkedEntityType, customFieldDefinition, limit, skip, sort, options) {
            return localVarFp.customFieldAssociationsGet(organizationId, linkedEntityType, customFieldDefinition, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionDelete(organizationId, customFieldDefinitionId, options) {
            return localVarFp.customFieldDefinitionDelete(organizationId, customFieldDefinitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom field definition
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionGet(organizationId, customFieldDefinitionId, options) {
            return localVarFp.customFieldDefinitionGet(organizationId, customFieldDefinitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the custom field definition for the given organization
         * @param {string} organizationId
         * @param {string} customFieldDefinitionId
         * @param {CustomFieldDefinitionUpdateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionUpdate(organizationId, customFieldDefinitionId, customFieldDefinition, options) {
            return localVarFp.customFieldDefinitionUpdate(organizationId, customFieldDefinitionId, customFieldDefinition, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a custom field definition
         * @param {string} organizationId
         * @param {CustomFieldDefinitionsCreateRequest} customFieldDefinition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsCreate(organizationId, customFieldDefinition, options) {
            return localVarFp.customFieldDefinitionsCreate(organizationId, customFieldDefinition, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of custom field definitions for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldDefinitionsGet(organizationId, limit, skip, sort, options) {
            return localVarFp.customFieldDefinitionsGet(organizationId, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueDelete(organizationId, customFieldEnumValueId, options) {
            return localVarFp.customFieldEnumValueDelete(organizationId, customFieldEnumValueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom field enum value
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueGet(organizationId, customFieldEnumValueId, options) {
            return localVarFp.customFieldEnumValueGet(organizationId, customFieldEnumValueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the custom field enum value for the given id
         * @param {string} organizationId
         * @param {string} customFieldEnumValueId
         * @param {CustomFieldEnumValueUpdateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValueUpdate(organizationId, customFieldEnumValueId, customFieldEnumValue, options) {
            return localVarFp.customFieldEnumValueUpdate(organizationId, customFieldEnumValueId, customFieldEnumValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Count the custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCount(organizationId, customFieldDefinition, limit, skip, sort, options) {
            return localVarFp.customFieldEnumValuesCount(organizationId, customFieldDefinition, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a custom field enum value
         * @param {string} organizationId
         * @param {CustomFieldEnumValuesCreateRequest} customFieldEnumValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesCreate(organizationId, customFieldEnumValue, options) {
            return localVarFp.customFieldEnumValuesCreate(organizationId, customFieldEnumValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of custom field enum values for the given organization
         * @param {string} organizationId
         * @param {string} [customFieldDefinition]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldEnumValuesGet(organizationId, customFieldDefinition, limit, skip, sort, options) {
            return localVarFp.customFieldEnumValuesGet(organizationId, customFieldDefinition, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the custom field values for the given organization on organizations only
         * @param {string} organizationId
         * @param {string} [linkedEntityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesGet(organizationId, linkedEntityId, options) {
            return localVarFp.customFieldValuesGet(organizationId, linkedEntityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the given custom field value for the given organization
         * @param {string} organizationId
         * @param {string} customFieldValueId
         * @param {CustomFieldValuesUpdateRequest} customFieldValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customFieldValuesUpdate(organizationId, customFieldValueId, customFieldValue, options) {
            return localVarFp.customFieldValuesUpdate(organizationId, customFieldValueId, customFieldValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionDelete(customerAccountId, defaultPermissionId, options) {
            return localVarFp.customerAccountsDefaultPermissionDelete(customerAccountId, defaultPermissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionGet(customerAccountId, defaultPermissionId, options) {
            return localVarFp.customerAccountsDefaultPermissionGet(customerAccountId, defaultPermissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {string} defaultPermissionId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionUpdate(customerAccountId, defaultPermissionId, defaultPermission, options) {
            return localVarFp.customerAccountsDefaultPermissionUpdate(customerAccountId, defaultPermissionId, defaultPermission, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of default permissions for a customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCount(customerAccountId, options) {
            return localVarFp.customerAccountsDefaultPermissionsCount(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a permission group
         * @param {string} customerAccountId
         * @param {CustomerAccountsDefaultPermissionsCreateRequest} defaultPermission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsCreate(customerAccountId, defaultPermission, options) {
            return localVarFp.customerAccountsDefaultPermissionsCreate(customerAccountId, defaultPermission, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the default permissions for a customer account
         * @param {string} customerAccountId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [externalGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsDefaultPermissionsGet(customerAccountId, limit, skip, sort, name, externalGroup, options) {
            return localVarFp.customerAccountsDefaultPermissionsGet(customerAccountId, limit, skip, sort, name, externalGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a customer account by id
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsGetById(customerAccountId, options) {
            return localVarFp.customerAccountsGetById(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a customer account
         * @param {string} customerAccountId
         * @param {CustomerAccountsUpdateRequest} customerAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerAccountsUpdate(customerAccountId, customerAccount, options) {
            return localVarFp.customerAccountsUpdate(customerAccountId, customerAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganization(customerAccountId, organizationId, options) {
            return localVarFp.deleteOrganization(customerAccountId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTheme(customerAccountId, themeId, options) {
            return localVarFp.deleteTheme(customerAccountId, themeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of documents
         * @param {string} building
         * @param {boolean} [archived]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [name]
         * @param {string} [extension]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options) {
            return localVarFp.documentsGetByBuilding(building, archived, limit, skip, sort, name, extension, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a document
         * @param {string} building
         * @param {File} file
         * @param {boolean} [attachment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsUpload(building, file, attachment, options) {
            return localVarFp.documentsUpload(building, file, attachment, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of field groups by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldGroupsGetByOrganization(organizationId, name, context, limit, skip, sort, options) {
            return localVarFp.fieldGroupsGetByOrganization(organizationId, name, context, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new file upload url
         * @param {string} organization
         * @param {FileCreateRequest} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileCreate(organization, file, options) {
            return localVarFp.fileCreate(organization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Get file
         * @param {string} organization
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileGet(organization, file, options) {
            return localVarFp.fileGet(organization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark file upload as completed
         * @param {string} organization
         * @param {string} file
         * @param {FilesCompleteUploadRequest} fileAction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesCompleteUpload(organization, file, fileAction, options) {
            return localVarFp.filesCompleteUpload(organization, file, fileAction, options).then((request) => request(axios, basePath));
        },
        /**
         * Get file
         * @param {string} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesGet(organization, options) {
            return localVarFp.filesGet(organization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of feature flags that are globally AND organizationally enable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flagsGet(options) {
            return localVarFp.flagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the active theme for the customer account (if there is one)
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveTheme(customerAccountId, options) {
            return localVarFp.getActiveTheme(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the importable fields for assets
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssetImportFields(targetId, updatable, options) {
            return localVarFp.getAssetImportFields(targetId, updatable, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authentication methods allowed by the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthnMethods(customerAccountId, options) {
            return localVarFp.getAuthnMethods(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the importable fields for buildings
         * @param {string} [targetId]
         * @param {boolean} [updatable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuildingImportFields(targetId, updatable, options) {
            return localVarFp.getBuildingImportFields(targetId, updatable, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the CSV rows result for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSVResult(importId, status, options) {
            return localVarFp.getCSVResult(importId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestration(customerAccountId, orchestrationId, options) {
            return localVarFp.getCustomerAccountOrchestration(customerAccountId, orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get steps for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, options) {
            return localVarFp.getCustomerAccountOrchestrationSteps(customerAccountId, orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get steps results as CSV for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsCSV(customerAccountId, orchestrationId, options) {
            return localVarFp.getCustomerAccountOrchestrationStepsCSV(customerAccountId, orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get steps statistics for an orchestration in a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrationStepsStats(customerAccountId, orchestrationId, options) {
            return localVarFp.getCustomerAccountOrchestrationStepsStats(customerAccountId, orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get orchestrations for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccountOrchestrations(customerAccountId, type, options) {
            return localVarFp.getCustomerAccountOrchestrations(customerAccountId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get customer accounts that belong to email and code combination
         * @param {GetCustomerAccountsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAccounts(body, options) {
            return localVarFp.getCustomerAccounts(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an organization within a customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationGetById(customerAccountId, organizationId, options) {
            return localVarFp.getOrganizationGetById(customerAccountId, organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets organizations within a customer account
         * @param {string} customerAccountId
         * @param {string} [name]
         * @param {string} [subdomainKey]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(customerAccountId, name, subdomainKey, sort, limit, skip, options) {
            return localVarFp.getOrganizations(customerAccountId, name, subdomainKey, sort, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the rows for the given import
         * @param {string} importId
         * @param {string} [status]
         * @param {number} [limit]
         * @param {string} [sort]
         * @param {string} [startKey]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRows(importId, status, limit, sort, startKey, skip, options) {
            return localVarFp.getRows(importId, status, limit, sort, startKey, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestration(orchestrationId, options) {
            return localVarFp.getSiteAdminOrchestration(orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get steps for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {number} [limit] Maximum number of steps to return
         * @param {string} [startKey] Pagination start key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationSteps(orchestrationId, status, limit, startKey, options) {
            return localVarFp.getSiteAdminOrchestrationSteps(orchestrationId, status, limit, startKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get steps results as CSV for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {StepStatus} [status] Filter steps by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsCSV(orchestrationId, status, options) {
            return localVarFp.getSiteAdminOrchestrationStepsCSV(orchestrationId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get steps statistics for an orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrationStepsStats(orchestrationId, options) {
            return localVarFp.getSiteAdminOrchestrationStepsStats(orchestrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get orchestrations
         * @param {OrchestrationTargetEntity} [targetEntity] Filter orchestrations by target entity
         * @param {string} [targetId] Filter orchestrations by target ID
         * @param {string} [type] Filter orchestrations by type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteAdminOrchestrations(targetEntity, targetId, type, options) {
            return localVarFp.getSiteAdminOrchestrations(targetEntity, targetId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTheme(customerAccountId, themeId, options) {
            return localVarFp.getTheme(customerAccountId, themeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of themes for the customer account
         * @param {string} customerAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemes(customerAccountId, options) {
            return localVarFp.getThemes(customerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCountUsers(options) {
            return localVarFp.identityCountUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a JWT for the email and password combination
         * @param {AdminOrganizationsUpdateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityCreateToken(body, options) {
            return localVarFp.identityCreateToken(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets data for the authenticated identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGet(options) {
            return localVarFp.identityGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of the active users for the authenticated identity
         * @param {string} [sisenseRole]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityGetUsers(sisenseRole, limit, options) {
            return localVarFp.identityGetUsers(sisenseRole, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Process the given CSV and bulk add the items for the given import_entity
         * @param {string} targetId ID of the target entity that the items will be imported.
         * @param {string} targetEntity Name of the target entity that the items will be imported. [e.g.: catalog]
         * @param {string} importEntity Name of the entity (items) that will be imported. [e.g.: catalog-items]
         * @param {File} files The file (csv) that contains the items that will be imported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCSV(targetId, targetEntity, importEntity, files, options) {
            return localVarFp.importCSV(targetId, targetEntity, importEntity, files, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the row actions stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowActionsStats(importId, options) {
            return localVarFp.importRowActionsStats(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks the rows stats for the given import
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importRowsStats(importId, options) {
            return localVarFp.importRowsStats(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [number]
         * @param {string} [name]
         * @param {string} [priority]
         * @param {string} [checklistTemplate]
         * @param {string} [assignees]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGet(organizationId, limit, skip, sortBy, status, number, name, priority, checklistTemplate, assignees, building, options) {
            return localVarFp.inspectionProgramsGet(organizationId, limit, skip, sortBy, status, number, name, priority, checklistTemplate, assignees, building, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of inspection programs for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionProgramsGetCount(organizationId, limit, skip, sortBy, status, options) {
            return localVarFp.inspectionProgramsGetCount(organizationId, limit, skip, sortBy, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all floors within an organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsByOrganization(organizationId, limit, skip, options) {
            return localVarFp.levelsByOrganization(organizationId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a floor within an organization
         * @param {string} organizationId
         * @param {string} levelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        levelsGetById(organizationId, levelId, options) {
            return localVarFp.levelsGetById(organizationId, levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the export process for the given exportId
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCancel(exportId, options) {
            return localVarFp.myExportsCancel(exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Process the given export request
         * @param {MyExportsCreateRequest} [myExportsCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsCreate(myExportsCreateRequest, options) {
            return localVarFp.myExportsCreate(myExportsCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the export by its id
         * @param {string} exportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsGet(exportId, options) {
            return localVarFp.myExportsGet(exportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of exports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [exportEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myExportsList(limit, startKey, status, targetEntity, targetId, exportEntity, options) {
            return localVarFp.myExportsList(limit, startKey, status, targetEntity, targetId, exportEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the import by its id
         * @param {string} importId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsGet(importId, options) {
            return localVarFp.myImportsGet(importId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of imports
         * @param {number} [limit]
         * @param {string} [startKey]
         * @param {string} [status]
         * @param {string} [targetEntity]
         * @param {string} [targetId]
         * @param {string} [importEntity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        myImportsList(limit, startKey, status, targetEntity, targetId, importEntity, options) {
            return localVarFp.myImportsList(limit, startKey, status, targetEntity, targetId, importEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the count of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsCount(options) {
            return localVarFp.organizationsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsDelete(organizationId, options) {
            return localVarFp.organizationsDelete(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of organizations
         * @param {string} [subdomain]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGet(subdomain, limit, skip, options) {
            return localVarFp.organizationsGet(subdomain, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an organization by id
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsGetById(organizationId, options) {
            return localVarFp.organizationsGetById(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an organization
         * @param {string} organizationId
         * @param {OrganizationsUpdateRequest} organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationsUpdate(organizationId, organization, options) {
            return localVarFp.organizationsUpdate(organizationId, organization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of permission groups by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionGroupsGet(organizationId, limit, skip, building, options) {
            return localVarFp.permissionGroupsGet(organizationId, limit, skip, building, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many pin type categories exists in the organization
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesCount(organizationId, options) {
            return localVarFp.pinTypesCount(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a pin type by id in a building
         * @param {string} buildingId
         * @param {string} pinTypeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetById(buildingId, pinTypeId, options) {
            return localVarFp.pinTypesGetById(buildingId, pinTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of pin type categories by organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [building]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinTypesGetByOrganization(organizationId, limit, skip, building, options) {
            return localVarFp.pinTypesGetByOrganization(organizationId, limit, skip, building, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the report content for a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [id]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [values]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewReportBlockContent(organizationId, reportBlockId, limit, skip, sort, id, building, pinType, name, address, values, options) {
            return localVarFp.previewReportBlockContent(organizationId, reportBlockId, limit, skip, sort, id, building, pinType, name, address, values, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of procore companies the user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetMyCompanies(options) {
            return localVarFp.procoreGetMyCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of procore projects in the provided company the user has access to
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProjectsByCompany(companyId, options) {
            return localVarFp.procoreGetProjectsByCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Forwards the provided endpoint with any params to Procore API and returns data response
         * @param {string} endpoint
         * @param {string} companyId
         * @param {number} [page]
         * @param {number} [projectId]
         * @param {number} [perPage]
         * @param {string} [filterType]
         * @param {number} [drawingAreaId]
         * @param {number} [drawingDisciplineId]
         * @param {string} [drawingSetId]
         * @param {number} [filtersSpecificationSectionId]
         * @param {number} [filtersStatusId]
         * @param {string} [filtersDocumentType]
         * @param {string} [filtersFolderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options) {
            return localVarFp.procoreGetProxy(endpoint, companyId, page, projectId, perPage, filterType, drawingAreaId, drawingDisciplineId, drawingSetId, filtersSpecificationSectionId, filtersStatusId, filtersDocumentType, filtersFolderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if the AkitaBox app is installed for the provided company and project (optionally)
         * @param {string} companyId
         * @param {string} [projectId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreIsAppInstalled(companyId, projectId, options) {
            return localVarFp.procoreIsAppInstalled(companyId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates procore oauth 2.0 flow
         * @param {string} redirectUrl
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procoreOauth(redirectUrl, options) {
            return localVarFp.procoreOauth(redirectUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * Pull files from Procore into AkitaBox
         * @param {string} buildingId
         * @param {string} organizationId
         * @param {ProcorePullFilesRequest} procorePullFilesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options) {
            return localVarFp.procorePullFiles(buildingId, organizationId, procorePullFilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report block content by report block id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentGetById(organizationId, reportBlockId, options) {
            return localVarFp.reportBlockContentGetById(organizationId, reportBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report block content
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlockContentUpdateRequest} reportBlockContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlockContentUpdate(organizationId, reportBlockId, reportBlockContent, options) {
            return localVarFp.reportBlockContentUpdate(organizationId, reportBlockId, reportBlockContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksDelete(organizationId, reportBlockId, options) {
            return localVarFp.reportBlocksDelete(organizationId, reportBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report block by its id
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetById(organizationId, reportBlockId, options) {
            return localVarFp.reportBlocksGetById(organizationId, reportBlockId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of report blocks by organization
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {'asset' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksGetByOrganization(organizationId, sort, context, limit, skip, options) {
            return localVarFp.reportBlocksGetByOrganization(organizationId, sort, context, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report block
         * @param {string} organizationId
         * @param {string} reportBlockId
         * @param {ReportBlocksUpdateRequest} reportBlock
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBlocksUpdate(organizationId, reportBlockId, reportBlock, options) {
            return localVarFp.reportBlocksUpdate(organizationId, reportBlockId, reportBlock, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report content by report id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentGetById(organizationId, reportId, options) {
            return localVarFp.reportContentGetById(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report content
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportContentUpdateRequest} reportContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportContentUpdate(organizationId, reportId, reportContent, options) {
            return localVarFp.reportContentUpdate(organizationId, reportId, reportContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new report footer or header
         * @param {string} organizationId
         * @param {ReportHeadersAndFootersCreateRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersCreate(organizationId, postBody, options) {
            return localVarFp.reportHeadersAndFootersCreate(organizationId, postBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report header/footer by id
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetById(organizationId, reportHeaderFooterId, options) {
            return localVarFp.reportHeadersAndFootersGetById(organizationId, reportHeaderFooterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report footers by their report id
         * @param {string} organizationId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetByOrganization(organizationId, report, reportTemplate, type, showPageNumbers, options) {
            return localVarFp.reportHeadersAndFootersGetByOrganization(organizationId, report, reportTemplate, type, showPageNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a content of the report header/footers
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {string} [report]
         * @param {string} [reportTemplate]
         * @param {'header' | 'footer'} [type]
         * @param {boolean} [showPageNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersGetContent(organizationId, reportHeaderFooterId, report, reportTemplate, type, showPageNumbers, options) {
            return localVarFp.reportHeadersAndFootersGetContent(organizationId, reportHeaderFooterId, report, reportTemplate, type, showPageNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUpdateRequest} payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUpdate(organizationId, reportHeaderFooterId, payload, options) {
            return localVarFp.reportHeadersAndFootersUpdate(organizationId, reportHeaderFooterId, payload, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads content to the header/footer
         * @param {string} organizationId
         * @param {string} reportHeaderFooterId
         * @param {ReportHeadersAndFootersUploadContentRequest} postBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportHeadersAndFootersUploadContent(organizationId, reportHeaderFooterId, postBody, options) {
            return localVarFp.reportHeadersAndFootersUploadContent(organizationId, reportHeaderFooterId, postBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report template content by id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentGetById(organizationId, reportTemplateId, options) {
            return localVarFp.reportTemplateContentGetById(organizationId, reportTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report template\'s content
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportContentUpdateRequest} reportTemplateContent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplateContentUpdate(organizationId, reportTemplateId, reportTemplateContent, options) {
            return localVarFp.reportTemplateContentUpdate(organizationId, reportTemplateId, reportTemplateContent, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many report templates are in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCount(organizationId, name, context, limit, skip, sort, options) {
            return localVarFp.reportTemplatesCount(organizationId, name, context, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new report template
         * @param {string} organizationId
         * @param {ReportTemplatesCreateRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesCreate(organizationId, reportTemplate, options) {
            return localVarFp.reportTemplatesCreate(organizationId, reportTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesDelete(organizationId, reportTemplateId, options) {
            return localVarFp.reportTemplatesDelete(organizationId, reportTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report template by its id
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetById(organizationId, reportTemplateId, options) {
            return localVarFp.reportTemplatesGetById(organizationId, reportTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of report templates by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {'organization' | 'building'} [context]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesGetByOrganization(organizationId, name, context, limit, skip, sort, options) {
            return localVarFp.reportTemplatesGetByOrganization(organizationId, name, context, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a report template
         * @param {string} organizationId
         * @param {string} reportTemplateId
         * @param {ReportTemplatesUpdateByIdRequest} reportTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplatesUpdateById(organizationId, reportTemplateId, reportTemplate, options) {
            return localVarFp.reportTemplatesUpdateById(organizationId, reportTemplateId, reportTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many reports exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCount(organizationId, name, options) {
            return localVarFp.reportsCount(organizationId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new report
         * @param {string} organizationId
         * @param {ReportsCreateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsCreate(organizationId, report, options) {
            return localVarFp.reportsCreate(organizationId, report, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsDelete(organizationId, reportId, options) {
            return localVarFp.reportsDelete(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a report by its id
         * @param {string} organizationId
         * @param {string} reportId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetById(organizationId, reportId, options) {
            return localVarFp.reportsGetById(organizationId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of reports by organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {boolean} [insensitive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options) {
            return localVarFp.reportsGetByOrganization(organizationId, name, sort, limit, skip, insensitive, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a report
         * @param {string} organizationId
         * @param {string} reportId
         * @param {ReportsUpdateRequest} report
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportsUpdate(organizationId, reportId, report, options) {
            return localVarFp.reportsUpdate(organizationId, reportId, report, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a room at the building level
         * @param {string} buildingId
         * @param {string} roomId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roomsGetById(buildingId, roomId, options) {
            return localVarFp.roomsGetById(buildingId, roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a saml config
         * @param {SamlConfigCreateRequest} samlConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        samlConfigCreate(samlConfig, options) {
            return localVarFp.samlConfigCreate(samlConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * Send an email to the provided email address
         * @param {SendEmailRequest} sendEmailRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(sendEmailRequest, options) {
            return localVarFp.sendEmail(sendEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Get the list of themes
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteAdminGetThemes(limit, skip, options) {
            return localVarFp.siteAdminGetThemes(limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the tag categories for a building
         * @param {string} building
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagsGetByBuilding(building, options) {
            return localVarFp.tagsGetByBuilding(building, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific orchestration for a customer account
         * @param {string} customerAccountId The customer account ID
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateCustomerAccountOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerAccountOrchestration(customerAccountId, orchestrationId, body, options) {
            return localVarFp.updateCustomerAccountOrchestration(customerAccountId, orchestrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the specified organization within the customer account
         * @param {string} customerAccountId
         * @param {string} organizationId
         * @param {UpdateOrganizationRequest} updateOrganizationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(customerAccountId, organizationId, updateOrganizationRequest, options) {
            return localVarFp.updateOrganization(customerAccountId, organizationId, updateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Site Admin: Update a specific orchestration
         * @param {string} orchestrationId The orchestration ID
         * @param {UpdateSiteAdminOrchestrationRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSiteAdminOrchestration(orchestrationId, body, options) {
            return localVarFp.updateSiteAdminOrchestration(orchestrationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a theme for the customer account
         * @param {string} customerAccountId
         * @param {string} themeId
         * @param {UpdateThemeRequest} updateThemeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTheme(customerAccountId, themeId, updateThemeRequest, options) {
            return localVarFp.updateTheme(customerAccountId, themeId, updateThemeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user at the org level
         * @param {string} organizationId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetById(organizationId, userId, options) {
            return localVarFp.usersGetById(organizationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets users in the orgainization
         * @param {string} organizationId
         * @param {string} [deactivateDate]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [email]
         * @param {string} [identity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetByOrganization(organizationId, deactivateDate, limit, skip, email, identity, options) {
            return localVarFp.usersGetByOrganization(organizationId, deactivateDate, limit, skip, email, identity, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the current organization user data
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersGetMyUser(organizationId, options) {
            return localVarFp.usersGetMyUser(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {string} [modifiedAt]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssets(orgId, decommissioned, insensitive, id, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, modifiedAt, hasAttachments, values, sort, limit, skip, options) {
            return localVarFp.webGetAssets(orgId, decommissioned, insensitive, id, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, modifiedAt, hasAttachments, values, sort, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * BFF Route for web-client asset list
         * @param {string} orgId
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {boolean} [insensitive]
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [roomName]
         * @param {string} [conditionConditionRating]
         * @param {string} [costlinesTotalCostWithAdjustments]
         * @param {string} [installationDate]
         * @param {boolean} [hasAttachments]
         * @param {string} [values]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetAssetsCount(orgId, sort, decommissioned, insensitive, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, hasAttachments, values, limit, skip, options) {
            return localVarFp.webGetAssetsCount(orgId, sort, decommissioned, insensitive, name, building, pinType, pinTypeName, level, roomNumber, roomName, conditionConditionRating, costlinesTotalCostWithAdjustments, installationDate, hasAttachments, values, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of buildings catered soley to the web front-end
         * @param {string} organizationId
         * @param {string} [sort]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildings(organizationId, sort, limit, skip, id, name, address, city, state, postalCode, customFieldValues, options) {
            return localVarFp.webGetBuildings(organizationId, sort, limit, skip, id, name, address, city, state, postalCode, customFieldValues, options).then((request) => request(axios, basePath));
        },
        /**
         * BFF Route for web-client buildings count
         * @param {string} organizationId
         * @param {string} [id]
         * @param {string} [name]
         * @param {string} [address]
         * @param {string} [city]
         * @param {string} [state]
         * @param {string} [postalCode]
         * @param {string} [customFieldValues]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetBuildingsCount(organizationId, id, name, address, city, state, postalCode, customFieldValues, options) {
            return localVarFp.webGetBuildingsCount(organizationId, id, name, address, city, state, postalCode, customFieldValues, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklists(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options) {
            return localVarFp.webGetChecklists(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of checklists for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [status]
         * @param {string} [complianceCode]
         * @param {string} [inspectionProgram]
         * @param {string} [inspectionProgramName]
         * @param {string} [inspectionProgramPriority]
         * @param {string} [inspectionProgramNumber]
         * @param {string} [inspectionProgramStatus]
         * @param {string} [inspection]
         * @param {string} [inspectionStartDate]
         * @param {string} [inspectionDueDate]
         * @param {string} [checklistTemplate]
         * @param {string} [checklistTemplateName]
         * @param {string} [completedUserDisplayName]
         * @param {string} [completedDate]
         * @param {string} [building]
         * @param {string} [pinTypeName]
         * @param {string} [level]
         * @param {string} [roomNumber]
         * @param {string} [assetName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetChecklistsCount(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options) {
            return localVarFp.webGetChecklistsCount(organizationId, limit, skip, sortBy, status, complianceCode, inspectionProgram, inspectionProgramName, inspectionProgramPriority, inspectionProgramNumber, inspectionProgramStatus, inspection, inspectionStartDate, inspectionDueDate, checklistTemplate, checklistTemplateName, completedUserDisplayName, completedDate, building, pinTypeName, level, roomNumber, assetName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of custom field associations for the given organization including custom field definitions and custom field enum values
         * @param {string} organizationId
         * @param {string} [linkedEntityType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldAssociations(organizationId, linkedEntityType, limit, skip, sort, options) {
            return localVarFp.webGetCustomFieldAssociations(organizationId, linkedEntityType, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of custom field definitions for the given organization including custom field associations
         * @param {string} organizationId
         * @param {string} [dataType]
         * @param {string} [name]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetCustomFieldDefinitions(organizationId, dataType, name, limit, skip, sort, options) {
            return localVarFp.webGetCustomFieldDefinitions(organizationId, dataType, name, limit, skip, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFields(organizationId, limit, skip, options) {
            return localVarFp.webGetFields(organizationId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of field names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetFieldsCount(organizationId, limit, skip, options) {
            return localVarFp.webGetFieldsCount(organizationId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of pin type names catered soley to the web front-end
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetPinTypeNames(organizationId, limit, skip, options) {
            return localVarFp.webGetPinTypeNames(organizationId, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many assets exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssetCount(organizationId, name, building, pinType, decommissioned, options) {
            return localVarFp.webGetReportBlockAssetCount(organizationId, name, building, pinType, decommissioned, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of assets catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {boolean} [decommissioned]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockAssets(organizationId, name, building, pinType, limit, skip, sort, decommissioned, options) {
            return localVarFp.webGetReportBlockAssets(organizationId, name, building, pinType, limit, skip, sort, decommissioned, options).then((request) => request(axios, basePath));
        },
        /**
         * Counts how many buildings exists in the organization
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {boolean} [decommissioned]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildingCount(organizationId, name, building, pinType, decommissioned, address, options) {
            return localVarFp.webGetReportBlockBuildingCount(organizationId, name, building, pinType, decommissioned, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of buildings catered soley to the report block dialog front-end
         * @param {string} organizationId
         * @param {string} [name]
         * @param {string} [building]
         * @param {string} [pinType]
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sort]
         * @param {string} [address]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetReportBlockBuildings(organizationId, name, building, pinType, limit, skip, sort, address, options) {
            return localVarFp.webGetReportBlockBuildings(organizationId, name, building, pinType, limit, skip, sort, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webGetWorkOrders(organizationId, limit, skip, sortBy, startDate, status, options) {
            return localVarFp.webGetWorkOrders(organizationId, limit, skip, sortBy, startDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGet(buildingId, limit, skip, sortBy, startDate, status, options) {
            return localVarFp.workOrdersGet(buildingId, limit, skip, sortBy, startDate, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of work orders for the given building
         * @param {string} buildingId
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetById(buildingId, taskId, options) {
            return localVarFp.workOrdersGetById(buildingId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the count of work orders for the given organization
         * @param {string} organizationId
         * @param {number} [limit]
         * @param {number} [skip]
         * @param {string} [sortBy]
         * @param {string} [startDate]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workOrdersGetCount(organizationId, limit, skip, sortBy, startDate, status, options) {
            return localVarFp.workOrdersGetCount(organizationId, limit, skip, sortBy, startDate, status, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     * Creates an account
     * @param {DefaultApiAccountCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    accountCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).accountCreate(requestParameters.customerAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of customer accounts
     * @param {DefaultApiAdminCustomerAccountsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCustomerAccountsCount(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminCustomerAccountsCount(requestParameters.name, requestParameters.canCreateOrganizations, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of customer accounts
     * @param {DefaultApiAdminCustomerAccountsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCustomerAccountsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminCustomerAccountsGet(requestParameters.sort, requestParameters.name, requestParameters.limit, requestParameters.skip, requestParameters.modifyIdentities, requestParameters.id, requestParameters.canCreateOrganizations, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a customer account by id
     * @param {DefaultApiAdminCustomerAccountsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCustomerAccountsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminCustomerAccountsGetById(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a customer account
     * @param {DefaultApiAdminCustomerAccountsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminCustomerAccountsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminCustomerAccountsUpdate(requestParameters.customerAccountId, requestParameters.customerAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates an identity
     * @param {DefaultApiAdminIdentitiesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminIdentitiesUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminIdentitiesUpdate(requestParameters.identityId, requestParameters.identity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of organizations
     * @param {DefaultApiAdminOrganizationsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminOrganizationsCount(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminOrganizationsCount(requestParameters.name, requestParameters.customerAccount, requestParameters.deactivatedDate, requestParameters.isDemo, requestParameters.subdomain, requestParameters.subdomainKey, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates an org
     * @param {DefaultApiAdminOrganizationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminOrganizationsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminOrganizationsCreate(requestParameters.organization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of organizations
     * @param {DefaultApiAdminOrganizationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminOrganizationsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminOrganizationsGet(requestParameters.sort, requestParameters.name, requestParameters.customerAccount, requestParameters.deactivatedDate, requestParameters.isDemo, requestParameters.subdomain, requestParameters.subdomainKey, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates an org
     * @param {DefaultApiAdminOrganizationsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminOrganizationsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminOrganizationsUpdate(requestParameters.organizationId, requestParameters.organization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a saml config
     * @param {DefaultApiAdminSAMLConfigDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminSAMLConfigDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminSAMLConfigDelete(requestParameters.samlConfigId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a saml config by id
     * @param {DefaultApiAdminSAMLConfigGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminSAMLConfigGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminSAMLConfigGetById(requestParameters.samlConfigId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a saml config
     * @param {DefaultApiAdminSAMLConfigUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminSAMLConfigUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminSAMLConfigUpdate(requestParameters.samlConfigId, requestParameters.samlConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of saml configs
     * @param {DefaultApiAdminSAMLConfigsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    adminSAMLConfigsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).adminSAMLConfigsGet(requestParameters.sort, requestParameters.customerAccount, requestParameters.domain, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many assets exists in the organization
     * @param {DefaultApiAssetsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assetsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assetsCount(requestParameters.organizationId, requestParameters.decommissioned, requestParameters.name, requestParameters.building, requestParameters.pinType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates an asset
     * @param {DefaultApiAssetsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assetsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assetsCreate(requestParameters.buildingId, requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets an asset at the building level
     * @param {DefaultApiAssetsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assetsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assetsGetById(requestParameters.buildingId, requestParameters.assetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates an asset at the building level
     * @param {DefaultApiAssetsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    assetsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).assetsUpdate(requestParameters.buildingId, requestParameters.assetId, requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many attachments exists in the building
     * @param {DefaultApiAttachmentsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsCount(requestParameters.building, requestParameters.linksEntityId, requestParameters.linksEntityType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new attachment
     * @param {DefaultApiAttachmentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsCreate(requestParameters.building, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get attachments by building, entity id, and entity type
     * @param {DefaultApiAttachmentsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsGetByBuilding(requestParameters.building, requestParameters.linksEntityId, requestParameters.linksEntityType, requestParameters.deleteDate, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get attachments by organization, entity id, and entity type
     * @param {DefaultApiAttachmentsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsGetByOrganization(requestParameters.organization, requestParameters.linksEntityId, requestParameters.linksEntityType, requestParameters.deleteDate, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a attachment
     * @param {DefaultApiAttachmentsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    attachmentsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).attachmentsUpdate(requestParameters.buildingId, requestParameters.attachmentId, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Federate an account
     * @param {DefaultApiAuthFederateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authFederate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).authFederate(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Requests an email to reset password
     * @param {DefaultApiAuthForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authForgotPassword(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).authForgotPassword(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Login to a profile
     * @param {DefaultApiAuthPasswordLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authPasswordLogin(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).authPasswordLogin(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Registers a user under a customer account
     * @param {DefaultApiAuthRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authRegister(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).authRegister(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Sends a verfication email to a newly created account
     * @param {DefaultApiAuthSendValidationEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    authSendValidationEmail(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).authSendValidationEmail(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a floor within a building
     * @param {DefaultApiBuildingLevelsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingLevelsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingLevelsGetById(requestParameters.buildingId, requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many buildings exists in the organization
     * @param {DefaultApiBuildingsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingsCount(requestParameters.organizationId, requestParameters.name, requestParameters.address, requestParameters.city, requestParameters.state, requestParameters.postalCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a building within an organization
     * @param {DefaultApiBuildingsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingsGetById(requestParameters.organizationId, requestParameters.buildingId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of buildings by organization
     * @param {DefaultApiBuildingsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingsGetByOrganization(requestParameters.organizationId, requestParameters.sort, requestParameters.limit, requestParameters.skip, requestParameters.name, requestParameters.address, requestParameters.city, requestParameters.state, requestParameters.postalCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a building within an organization
     * @param {DefaultApiBuildingsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    buildingsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).buildingsUpdate(requestParameters.organizationId, requestParameters.buildingId, requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancel the import process for the given importId
     * @param {DefaultApiCancelImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelImport(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).cancelImport(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets data from a catalog by its id
     * @param {DefaultApiCatalogGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogGet(requestParameters.catalogId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a catalog item
     * @param {DefaultApiCatalogItemGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemGet(requestParameters.catalogId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many catalog items exists
     * @param {DefaultApiCatalogItemsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsCount(requestParameters.catalogId, requestParameters.itemId, requestParameters.name, requestParameters.description, requestParameters.quantityUnit, requestParameters.size, requestParameters.sizeUnit, requestParameters.frequency, requestParameters.materialsUnitCostCents, requestParameters.laborUnitCostCents, requestParameters.equipmentUnitCostCents, requestParameters.unitCostCents, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new catalog item
     * @param {DefaultApiCatalogItemsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsCreate(requestParameters.catalogId, requestParameters.catalogItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes an item from a catalog
     * @param {DefaultApiCatalogItemsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsDelete(requestParameters.catalogId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of items of a catalog
     * @param {DefaultApiCatalogItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsGet(requestParameters.catalogId, requestParameters.itemId, requestParameters.name, requestParameters.description, requestParameters.quantityUnit, requestParameters.size, requestParameters.sizeUnit, requestParameters.frequency, requestParameters.materialsUnitCostCents, requestParameters.laborUnitCostCents, requestParameters.equipmentUnitCostCents, requestParameters.unitCostCents, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a catalog item
     * @param {DefaultApiCatalogItemsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogItemsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogItemsUpdate(requestParameters.catalogId, requestParameters.itemId, requestParameters.catalogItem, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a catalog
     * @param {DefaultApiCatalogUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogUpdate(requestParameters.catalogId, requestParameters.catalog, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many catalogs exists
     * @param {DefaultApiCatalogsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsCount(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsCount(requestParameters.name, requestParameters.modifiedDateMs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new catalog
     * @param {DefaultApiCatalogsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsCreate(requestParameters.catalog, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of Catalogs
     * @param {DefaultApiCatalogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    catalogsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).catalogsGet(requestParameters.name, requestParameters.modifiedDateMs, requestParameters.limit, requestParameters.sort, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of checklist templates for the given organization
     * @param {DefaultApiChecklistTemplatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checklistTemplatesGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).checklistTemplatesGet(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.status, requestParameters.id, requestParameters.name, requestParameters.complianceCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a checklist template in the given organization
     * @param {DefaultApiChecklistTemplatesGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checklistTemplatesGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).checklistTemplatesGetById(requestParameters.organizationId, requestParameters.checklistTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of checklists for the given organization
     * @param {DefaultApiChecklistsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checklistsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).checklistsCount(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.asset, requestParameters.building, requestParameters.status, requestParameters.complianceCode, requestParameters.inspectionProgramId, requestParameters.inspectionProgramName, requestParameters.inspectionProgramPriority, requestParameters.inspectionProgramNumber, requestParameters.inspectionProgramStatus, requestParameters.inspectionId, requestParameters.inspectionStartDate, requestParameters.inspectionDueDate, requestParameters.checklistTemplate, requestParameters.completedDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of checklists for the given organization
     * @param {DefaultApiChecklistsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checklistsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).checklistsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.asset, requestParameters.building, requestParameters.status, requestParameters.complianceCode, requestParameters.checklistTemplate, requestParameters.completedDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the stats of checklists for the given organization
     * @param {DefaultApiChecklistsStatsGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checklistsStatsGroup(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).checklistsStatsGroup(requestParameters.organizationId, requestParameters.groupField, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.asset, requestParameters.building, requestParameters.status, requestParameters.complianceCode, requestParameters.inspectionProgramId, requestParameters.inspectionProgramName, requestParameters.inspectionProgramPriority, requestParameters.inspectionProgramNumber, requestParameters.inspectionProgramStatus, requestParameters.inspectionId, requestParameters.inspectionStartDate, requestParameters.inspectionDueDate, requestParameters.checklistTemplate, requestParameters.completedDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Fetch token for CKEditor
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    ckeditorGetToken(options) {
        return (0, exports.DefaultApiFp)(this.configuration).ckeditorGetToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Generate a confirmation code to login
     * @param {DefaultApiConfirmationCodeCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    confirmationCodeCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).confirmationCodeCreate(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get cost data for the provided line number and catalog in the building\'s catalog location and release
     * @param {DefaultApiCostDataGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    costDataGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).costDataGetByBuilding(requestParameters.buildingId, requestParameters.catalogType, requestParameters.lineNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of cost lines by building
     * @param {DefaultApiCostLinesGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    costLinesGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).costLinesGetByBuilding(requestParameters.buildingId, requestParameters.limit, requestParameters.skip, requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a cost line by id in a building
     * @param {DefaultApiCostLinesGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    costLinesGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).costLinesGetById(requestParameters.buildingId, requestParameters.costLineId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of cost lines by organization
     * @param {DefaultApiCostLinesGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    costLinesGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).costLinesGetByOrganization(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.building, requestParameters.asset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a cost line in a building
     * @param {DefaultApiCostLinesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    costLinesUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).costLinesUpdate(requestParameters.buildingId, requestParameters.costLineId, requestParameters.costLine, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts organizations within a customer account
     * @param {DefaultApiCountOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    countOrganizations(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).countOrganizations(requestParameters.customerAccountId, requestParameters.name, requestParameters.subdomainKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new orchestration for a customer account
     * @param {DefaultApiCreateCustomerAccountOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createCustomerAccountOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createCustomerAccountOrchestration(requestParameters.customerAccountId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create steps for an orchestration in a customer account
     * @param {DefaultApiCreateCustomerAccountOrchestrationStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createCustomerAccountOrchestrationSteps(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createCustomerAccountOrchestrationSteps(requestParameters.customerAccountId, requestParameters.orchestrationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates an organizations within a customer account
     * @param {DefaultApiCreateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createOrganization(requestParameters.customerAccountId, requestParameters.createOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Create a new orchestration
     * @param {DefaultApiCreateSiteAdminOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSiteAdminOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createSiteAdminOrchestration(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Create steps for an orchestration
     * @param {DefaultApiCreateSiteAdminOrchestrationStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createSiteAdminOrchestrationSteps(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createSiteAdminOrchestrationSteps(requestParameters.orchestrationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create a new theme for the customer account
     * @param {DefaultApiCreateThemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createTheme(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createTheme(requestParameters.customerAccountId, requestParameters.createThemeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * creates a JWT for the email, code and customer account combination
     * @param {DefaultApiCreateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).createToken(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a custom field association
     * @param {DefaultApiCustomFieldAssociationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldAssociationDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldAssociationDelete(requestParameters.organizationId, requestParameters.customFieldAssociationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the custom field association
     * @param {DefaultApiCustomFieldAssociationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldAssociationGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldAssociationGet(requestParameters.organizationId, requestParameters.customFieldAssociationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the custom field association for the given organization
     * @param {DefaultApiCustomFieldAssociationUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldAssociationUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldAssociationUpdate(requestParameters.organizationId, requestParameters.customFieldAssociationId, requestParameters.customFieldAssociation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a custom field association
     * @param {DefaultApiCustomFieldAssociationsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldAssociationsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldAssociationsCreate(requestParameters.organizationId, requestParameters.customFieldAssociation, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of custom field associations for the given organization
     * @param {DefaultApiCustomFieldAssociationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldAssociationsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldAssociationsGet(requestParameters.organizationId, requestParameters.linkedEntityType, requestParameters.customFieldDefinition, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a custom field definition
     * @param {DefaultApiCustomFieldDefinitionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldDefinitionDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldDefinitionDelete(requestParameters.organizationId, requestParameters.customFieldDefinitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the custom field definition
     * @param {DefaultApiCustomFieldDefinitionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldDefinitionGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldDefinitionGet(requestParameters.organizationId, requestParameters.customFieldDefinitionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the custom field definition for the given organization
     * @param {DefaultApiCustomFieldDefinitionUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldDefinitionUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldDefinitionUpdate(requestParameters.organizationId, requestParameters.customFieldDefinitionId, requestParameters.customFieldDefinition, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a custom field definition
     * @param {DefaultApiCustomFieldDefinitionsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldDefinitionsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldDefinitionsCreate(requestParameters.organizationId, requestParameters.customFieldDefinition, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of custom field definitions for the given organization
     * @param {DefaultApiCustomFieldDefinitionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldDefinitionsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldDefinitionsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a custom field enum value
     * @param {DefaultApiCustomFieldEnumValueDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValueDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValueDelete(requestParameters.organizationId, requestParameters.customFieldEnumValueId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the custom field enum value
     * @param {DefaultApiCustomFieldEnumValueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValueGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValueGet(requestParameters.organizationId, requestParameters.customFieldEnumValueId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the custom field enum value for the given id
     * @param {DefaultApiCustomFieldEnumValueUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValueUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValueUpdate(requestParameters.organizationId, requestParameters.customFieldEnumValueId, requestParameters.customFieldEnumValue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Count the custom field enum values for the given organization
     * @param {DefaultApiCustomFieldEnumValuesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValuesCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValuesCount(requestParameters.organizationId, requestParameters.customFieldDefinition, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a custom field enum value
     * @param {DefaultApiCustomFieldEnumValuesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValuesCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValuesCreate(requestParameters.organizationId, requestParameters.customFieldEnumValue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of custom field enum values for the given organization
     * @param {DefaultApiCustomFieldEnumValuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldEnumValuesGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldEnumValuesGet(requestParameters.organizationId, requestParameters.customFieldDefinition, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the custom field values for the given organization on organizations only
     * @param {DefaultApiCustomFieldValuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldValuesGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldValuesGet(requestParameters.organizationId, requestParameters.linkedEntityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update the given custom field value for the given organization
     * @param {DefaultApiCustomFieldValuesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customFieldValuesUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customFieldValuesUpdate(requestParameters.organizationId, requestParameters.customFieldValueId, requestParameters.customFieldValue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a permission group
     * @param {DefaultApiCustomerAccountsDefaultPermissionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionDelete(requestParameters.customerAccountId, requestParameters.defaultPermissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the default permissions for a customer account
     * @param {DefaultApiCustomerAccountsDefaultPermissionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionGet(requestParameters.customerAccountId, requestParameters.defaultPermissionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a permission group
     * @param {DefaultApiCustomerAccountsDefaultPermissionUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionUpdate(requestParameters.customerAccountId, requestParameters.defaultPermissionId, requestParameters.defaultPermission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of default permissions for a customer account
     * @param {DefaultApiCustomerAccountsDefaultPermissionsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionsCount(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a permission group
     * @param {DefaultApiCustomerAccountsDefaultPermissionsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionsCreate(requestParameters.customerAccountId, requestParameters.defaultPermission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the default permissions for a customer account
     * @param {DefaultApiCustomerAccountsDefaultPermissionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsDefaultPermissionsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsDefaultPermissionsGet(requestParameters.customerAccountId, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.name, requestParameters.externalGroup, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a customer account by id
     * @param {DefaultApiCustomerAccountsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsGetById(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a customer account
     * @param {DefaultApiCustomerAccountsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customerAccountsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).customerAccountsUpdate(requestParameters.customerAccountId, requestParameters.customerAccount, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes the specified organization within the customer account
     * @param {DefaultApiDeleteOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteOrganization(requestParameters.customerAccountId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Delete a theme for the customer account
     * @param {DefaultApiDeleteThemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteTheme(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).deleteTheme(requestParameters.customerAccountId, requestParameters.themeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get list of documents
     * @param {DefaultApiDocumentsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentsGetByBuilding(requestParameters.building, requestParameters.archived, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.name, requestParameters.extension, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Upload a document
     * @param {DefaultApiDocumentsUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    documentsUpload(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).documentsUpload(requestParameters.building, requestParameters.file, requestParameters.attachment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of field groups by organization
     * @param {DefaultApiFieldGroupsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    fieldGroupsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).fieldGroupsGetByOrganization(requestParameters.organizationId, requestParameters.name, requestParameters.context, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Create new file upload url
     * @param {DefaultApiFileCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    fileCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).fileCreate(requestParameters.organization, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get file
     * @param {DefaultApiFileGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    fileGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).fileGet(requestParameters.organization, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Mark file upload as completed
     * @param {DefaultApiFilesCompleteUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    filesCompleteUpload(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).filesCompleteUpload(requestParameters.organization, requestParameters.file, requestParameters.fileAction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get file
     * @param {DefaultApiFilesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    filesGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).filesGet(requestParameters.organization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of feature flags that are globally AND organizationally enable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    flagsGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).flagsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the active theme for the customer account (if there is one)
     * @param {DefaultApiGetActiveThemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getActiveTheme(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getActiveTheme(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the importable fields for assets
     * @param {DefaultApiGetAssetImportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAssetImportFields(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAssetImportFields(requestParameters.targetId, requestParameters.updatable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the authentication methods allowed by the customer account
     * @param {DefaultApiGetAuthnMethodsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAuthnMethods(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getAuthnMethods(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the importable fields for buildings
     * @param {DefaultApiGetBuildingImportFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getBuildingImportFields(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getBuildingImportFields(requestParameters.targetId, requestParameters.updatable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the CSV rows result for the given import
     * @param {DefaultApiGetCSVResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCSVResult(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCSVResult(requestParameters.importId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a specific orchestration for a customer account
     * @param {DefaultApiGetCustomerAccountOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccountOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccountOrchestration(requestParameters.customerAccountId, requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get steps for an orchestration in a customer account
     * @param {DefaultApiGetCustomerAccountOrchestrationStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccountOrchestrationSteps(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccountOrchestrationSteps(requestParameters.customerAccountId, requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get steps results as CSV for an orchestration in a customer account
     * @param {DefaultApiGetCustomerAccountOrchestrationStepsCSVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccountOrchestrationStepsCSV(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccountOrchestrationStepsCSV(requestParameters.customerAccountId, requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get steps statistics for an orchestration in a customer account
     * @param {DefaultApiGetCustomerAccountOrchestrationStepsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccountOrchestrationStepsStats(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccountOrchestrationStepsStats(requestParameters.customerAccountId, requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get orchestrations for a customer account
     * @param {DefaultApiGetCustomerAccountOrchestrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccountOrchestrations(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccountOrchestrations(requestParameters.customerAccountId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get customer accounts that belong to email and code combination
     * @param {DefaultApiGetCustomerAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCustomerAccounts(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getCustomerAccounts(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets an organization within a customer account
     * @param {DefaultApiGetOrganizationGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getOrganizationGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getOrganizationGetById(requestParameters.customerAccountId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets organizations within a customer account
     * @param {DefaultApiGetOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getOrganizations(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getOrganizations(requestParameters.customerAccountId, requestParameters.name, requestParameters.subdomainKey, requestParameters.sort, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the rows for the given import
     * @param {DefaultApiGetRowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getRows(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getRows(requestParameters.importId, requestParameters.status, requestParameters.limit, requestParameters.sort, requestParameters.startKey, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get a specific orchestration
     * @param {DefaultApiGetSiteAdminOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSiteAdminOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getSiteAdminOrchestration(requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get steps for an orchestration
     * @param {DefaultApiGetSiteAdminOrchestrationStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSiteAdminOrchestrationSteps(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getSiteAdminOrchestrationSteps(requestParameters.orchestrationId, requestParameters.status, requestParameters.limit, requestParameters.startKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get steps results as CSV for an orchestration
     * @param {DefaultApiGetSiteAdminOrchestrationStepsCSVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSiteAdminOrchestrationStepsCSV(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getSiteAdminOrchestrationStepsCSV(requestParameters.orchestrationId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get steps statistics for an orchestration
     * @param {DefaultApiGetSiteAdminOrchestrationStepsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSiteAdminOrchestrationStepsStats(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getSiteAdminOrchestrationStepsStats(requestParameters.orchestrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get orchestrations
     * @param {DefaultApiGetSiteAdminOrchestrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSiteAdminOrchestrations(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getSiteAdminOrchestrations(requestParameters.targetEntity, requestParameters.targetId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a theme for the customer account
     * @param {DefaultApiGetThemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getTheme(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getTheme(requestParameters.customerAccountId, requestParameters.themeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of themes for the customer account
     * @param {DefaultApiGetThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getThemes(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).getThemes(requestParameters.customerAccountId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of the active users for the authenticated identity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    identityCountUsers(options) {
        return (0, exports.DefaultApiFp)(this.configuration).identityCountUsers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a JWT for the email and password combination
     * @param {DefaultApiIdentityCreateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    identityCreateToken(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).identityCreateToken(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets data for the authenticated identity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    identityGet(options) {
        return (0, exports.DefaultApiFp)(this.configuration).identityGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of the active users for the authenticated identity
     * @param {DefaultApiIdentityGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    identityGetUsers(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).identityGetUsers(requestParameters.sisenseRole, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Process the given CSV and bulk add the items for the given import_entity
     * @param {DefaultApiImportCSVRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importCSV(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importCSV(requestParameters.targetId, requestParameters.targetEntity, requestParameters.importEntity, requestParameters.files, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks the row actions stats for the given import
     * @param {DefaultApiImportRowActionsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importRowActionsStats(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importRowActionsStats(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks the rows stats for the given import
     * @param {DefaultApiImportRowsStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    importRowsStats(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).importRowsStats(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of inspection programs for the given organization
     * @param {DefaultApiInspectionProgramsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    inspectionProgramsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).inspectionProgramsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.status, requestParameters.number, requestParameters.name, requestParameters.priority, requestParameters.checklistTemplate, requestParameters.assignees, requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of inspection programs for the given organization
     * @param {DefaultApiInspectionProgramsGetCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    inspectionProgramsGetCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).inspectionProgramsGetCount(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets all floors within an organization
     * @param {DefaultApiLevelsByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    levelsByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).levelsByOrganization(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a floor within an organization
     * @param {DefaultApiLevelsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    levelsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).levelsGetById(requestParameters.organizationId, requestParameters.levelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Cancel the export process for the given exportId
     * @param {DefaultApiMyExportsCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myExportsCancel(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myExportsCancel(requestParameters.exportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Process the given export request
     * @param {DefaultApiMyExportsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myExportsCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myExportsCreate(requestParameters.myExportsCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the export by its id
     * @param {DefaultApiMyExportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myExportsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myExportsGet(requestParameters.exportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of exports
     * @param {DefaultApiMyExportsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myExportsList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myExportsList(requestParameters.limit, requestParameters.startKey, requestParameters.status, requestParameters.targetEntity, requestParameters.targetId, requestParameters.exportEntity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the import by its id
     * @param {DefaultApiMyImportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myImportsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myImportsGet(requestParameters.importId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of imports
     * @param {DefaultApiMyImportsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    myImportsList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).myImportsList(requestParameters.limit, requestParameters.startKey, requestParameters.status, requestParameters.targetEntity, requestParameters.targetId, requestParameters.importEntity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the count of organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsCount(options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsCount(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes an organization
     * @param {DefaultApiOrganizationsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsDelete(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of organizations
     * @param {DefaultApiOrganizationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsGet(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsGet(requestParameters.subdomain, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets an organization by id
     * @param {DefaultApiOrganizationsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsGetById(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates an organization
     * @param {DefaultApiOrganizationsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    organizationsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).organizationsUpdate(requestParameters.organizationId, requestParameters.organization, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of permission groups by organization
     * @param {DefaultApiPermissionGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    permissionGroupsGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).permissionGroupsGet(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many pin type categories exists in the organization
     * @param {DefaultApiPinTypesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pinTypesCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).pinTypesCount(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a pin type by id in a building
     * @param {DefaultApiPinTypesGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pinTypesGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).pinTypesGetById(requestParameters.buildingId, requestParameters.pinTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of pin type categories by organization
     * @param {DefaultApiPinTypesGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    pinTypesGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).pinTypesGetByOrganization(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the report content for a report block
     * @param {DefaultApiPreviewReportBlockContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    previewReportBlockContent(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).previewReportBlockContent(requestParameters.organizationId, requestParameters.reportBlockId, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.id, requestParameters.building, requestParameters.pinType, requestParameters.name, requestParameters.address, requestParameters.values, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of procore companies the user has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetMyCompanies(options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetMyCompanies(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of procore projects in the provided company the user has access to
     * @param {DefaultApiProcoreGetProjectsByCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetProjectsByCompany(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetProjectsByCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Forwards the provided endpoint with any params to Procore API and returns data response
     * @param {DefaultApiProcoreGetProxyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreGetProxy(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreGetProxy(requestParameters.endpoint, requestParameters.companyId, requestParameters.page, requestParameters.projectId, requestParameters.perPage, requestParameters.filterType, requestParameters.drawingAreaId, requestParameters.drawingDisciplineId, requestParameters.drawingSetId, requestParameters.filtersSpecificationSectionId, requestParameters.filtersStatusId, requestParameters.filtersDocumentType, requestParameters.filtersFolderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks if the AkitaBox app is installed for the provided company and project (optionally)
     * @param {DefaultApiProcoreIsAppInstalledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreIsAppInstalled(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreIsAppInstalled(requestParameters.companyId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Initiates procore oauth 2.0 flow
     * @param {DefaultApiProcoreOauthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procoreOauth(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procoreOauth(requestParameters.redirectUrl, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Pull files from Procore into AkitaBox
     * @param {DefaultApiProcorePullFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    procorePullFiles(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).procorePullFiles(requestParameters.buildingId, requestParameters.organizationId, requestParameters.procorePullFilesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report block content by report block id
     * @param {DefaultApiReportBlockContentGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlockContentGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlockContentGetById(requestParameters.organizationId, requestParameters.reportBlockId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report block content
     * @param {DefaultApiReportBlockContentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlockContentUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlockContentUpdate(requestParameters.organizationId, requestParameters.reportBlockId, requestParameters.reportBlockContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a report block
     * @param {DefaultApiReportBlocksDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlocksDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlocksDelete(requestParameters.organizationId, requestParameters.reportBlockId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report block by its id
     * @param {DefaultApiReportBlocksGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlocksGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlocksGetById(requestParameters.organizationId, requestParameters.reportBlockId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of report blocks by organization
     * @param {DefaultApiReportBlocksGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlocksGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlocksGetByOrganization(requestParameters.organizationId, requestParameters.sort, requestParameters.context, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report block
     * @param {DefaultApiReportBlocksUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportBlocksUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportBlocksUpdate(requestParameters.organizationId, requestParameters.reportBlockId, requestParameters.reportBlock, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report content by report id
     * @param {DefaultApiReportContentGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportContentGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportContentGetById(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report content
     * @param {DefaultApiReportContentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportContentUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportContentUpdate(requestParameters.organizationId, requestParameters.reportId, requestParameters.reportContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new report footer or header
     * @param {DefaultApiReportHeadersAndFootersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersCreate(requestParameters.organizationId, requestParameters.postBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report header/footer by id
     * @param {DefaultApiReportHeadersAndFootersGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersGetById(requestParameters.organizationId, requestParameters.reportHeaderFooterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report footers by their report id
     * @param {DefaultApiReportHeadersAndFootersGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersGetByOrganization(requestParameters.organizationId, requestParameters.report, requestParameters.reportTemplate, requestParameters.type, requestParameters.showPageNumbers, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a content of the report header/footers
     * @param {DefaultApiReportHeadersAndFootersGetContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersGetContent(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersGetContent(requestParameters.organizationId, requestParameters.reportHeaderFooterId, requestParameters.report, requestParameters.reportTemplate, requestParameters.type, requestParameters.showPageNumbers, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report header/footer
     * @param {DefaultApiReportHeadersAndFootersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersUpdate(requestParameters.organizationId, requestParameters.reportHeaderFooterId, requestParameters.payload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Uploads content to the header/footer
     * @param {DefaultApiReportHeadersAndFootersUploadContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportHeadersAndFootersUploadContent(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportHeadersAndFootersUploadContent(requestParameters.organizationId, requestParameters.reportHeaderFooterId, requestParameters.postBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report template content by id
     * @param {DefaultApiReportTemplateContentGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplateContentGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplateContentGetById(requestParameters.organizationId, requestParameters.reportTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report template\'s content
     * @param {DefaultApiReportTemplateContentUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplateContentUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplateContentUpdate(requestParameters.organizationId, requestParameters.reportTemplateId, requestParameters.reportTemplateContent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many report templates are in the organization
     * @param {DefaultApiReportTemplatesCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesCount(requestParameters.organizationId, requestParameters.name, requestParameters.context, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new report template
     * @param {DefaultApiReportTemplatesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesCreate(requestParameters.organizationId, requestParameters.reportTemplate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a report template
     * @param {DefaultApiReportTemplatesDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesDelete(requestParameters.organizationId, requestParameters.reportTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report template by its id
     * @param {DefaultApiReportTemplatesGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesGetById(requestParameters.organizationId, requestParameters.reportTemplateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of report templates by organization
     * @param {DefaultApiReportTemplatesGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesGetByOrganization(requestParameters.organizationId, requestParameters.name, requestParameters.context, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a report template
     * @param {DefaultApiReportTemplatesUpdateByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportTemplatesUpdateById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportTemplatesUpdateById(requestParameters.organizationId, requestParameters.reportTemplateId, requestParameters.reportTemplate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many reports exists in the organization
     * @param {DefaultApiReportsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsCount(requestParameters.organizationId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new report
     * @param {DefaultApiReportsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsCreate(requestParameters.organizationId, requestParameters.report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Deletes a report
     * @param {DefaultApiReportsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsDelete(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsDelete(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a report by its id
     * @param {DefaultApiReportsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsGetById(requestParameters.organizationId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of reports by organization
     * @param {DefaultApiReportsGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsGetByOrganization(requestParameters.organizationId, requestParameters.name, requestParameters.sort, requestParameters.limit, requestParameters.skip, requestParameters.insensitive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates a report
     * @param {DefaultApiReportsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportsUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).reportsUpdate(requestParameters.organizationId, requestParameters.reportId, requestParameters.report, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets a room at the building level
     * @param {DefaultApiRoomsGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    roomsGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).roomsGetById(requestParameters.buildingId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a saml config
     * @param {DefaultApiSamlConfigCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    samlConfigCreate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).samlConfigCreate(requestParameters.samlConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Send an email to the provided email address
     * @param {DefaultApiSendEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sendEmail(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).sendEmail(requestParameters.sendEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Get the list of themes
     * @param {DefaultApiSiteAdminGetThemesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    siteAdminGetThemes(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).siteAdminGetThemes(requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the tag categories for a building
     * @param {DefaultApiTagsGetByBuildingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    tagsGetByBuilding(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).tagsGetByBuilding(requestParameters.building, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a specific orchestration for a customer account
     * @param {DefaultApiUpdateCustomerAccountOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateCustomerAccountOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateCustomerAccountOrchestration(requestParameters.customerAccountId, requestParameters.orchestrationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Updates the specified organization within the customer account
     * @param {DefaultApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateOrganization(requestParameters.customerAccountId, requestParameters.organizationId, requestParameters.updateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Site Admin: Update a specific orchestration
     * @param {DefaultApiUpdateSiteAdminOrchestrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateSiteAdminOrchestration(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateSiteAdminOrchestration(requestParameters.orchestrationId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update a theme for the customer account
     * @param {DefaultApiUpdateThemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateTheme(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).updateTheme(requestParameters.customerAccountId, requestParameters.themeId, requestParameters.updateThemeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a user at the org level
     * @param {DefaultApiUsersGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    usersGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).usersGetById(requestParameters.organizationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets users in the orgainization
     * @param {DefaultApiUsersGetByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    usersGetByOrganization(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).usersGetByOrganization(requestParameters.organizationId, requestParameters.deactivateDate, requestParameters.limit, requestParameters.skip, requestParameters.email, requestParameters.identity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the current organization user data
     * @param {DefaultApiUsersGetMyUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    usersGetMyUser(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).usersGetMyUser(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * BFF Route for web-client asset list
     * @param {DefaultApiWebGetAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetAssets(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetAssets(requestParameters.orgId, requestParameters.decommissioned, requestParameters.insensitive, requestParameters.id, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.pinTypeName, requestParameters.level, requestParameters.roomNumber, requestParameters.roomName, requestParameters.conditionConditionRating, requestParameters.costlinesTotalCostWithAdjustments, requestParameters.installationDate, requestParameters.modifiedAt, requestParameters.hasAttachments, requestParameters.values, requestParameters.sort, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * BFF Route for web-client asset list
     * @param {DefaultApiWebGetAssetsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetAssetsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetAssetsCount(requestParameters.orgId, requestParameters.sort, requestParameters.decommissioned, requestParameters.insensitive, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.pinTypeName, requestParameters.level, requestParameters.roomNumber, requestParameters.roomName, requestParameters.conditionConditionRating, requestParameters.costlinesTotalCostWithAdjustments, requestParameters.installationDate, requestParameters.hasAttachments, requestParameters.values, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of buildings catered soley to the web front-end
     * @param {DefaultApiWebGetBuildingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetBuildings(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetBuildings(requestParameters.organizationId, requestParameters.sort, requestParameters.limit, requestParameters.skip, requestParameters.id, requestParameters.name, requestParameters.address, requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.customFieldValues, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * BFF Route for web-client buildings count
     * @param {DefaultApiWebGetBuildingsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetBuildingsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetBuildingsCount(requestParameters.organizationId, requestParameters.id, requestParameters.name, requestParameters.address, requestParameters.city, requestParameters.state, requestParameters.postalCode, requestParameters.customFieldValues, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of checklists for the given organization
     * @param {DefaultApiWebGetChecklistsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetChecklists(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetChecklists(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.status, requestParameters.complianceCode, requestParameters.inspectionProgram, requestParameters.inspectionProgramName, requestParameters.inspectionProgramPriority, requestParameters.inspectionProgramNumber, requestParameters.inspectionProgramStatus, requestParameters.inspection, requestParameters.inspectionStartDate, requestParameters.inspectionDueDate, requestParameters.checklistTemplate, requestParameters.checklistTemplateName, requestParameters.completedUserDisplayName, requestParameters.completedDate, requestParameters.building, requestParameters.pinTypeName, requestParameters.level, requestParameters.roomNumber, requestParameters.assetName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of checklists for the given organization
     * @param {DefaultApiWebGetChecklistsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetChecklistsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetChecklistsCount(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.status, requestParameters.complianceCode, requestParameters.inspectionProgram, requestParameters.inspectionProgramName, requestParameters.inspectionProgramPriority, requestParameters.inspectionProgramNumber, requestParameters.inspectionProgramStatus, requestParameters.inspection, requestParameters.inspectionStartDate, requestParameters.inspectionDueDate, requestParameters.checklistTemplate, requestParameters.checklistTemplateName, requestParameters.completedUserDisplayName, requestParameters.completedDate, requestParameters.building, requestParameters.pinTypeName, requestParameters.level, requestParameters.roomNumber, requestParameters.assetName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of custom field associations for the given organization including custom field definitions and custom field enum values
     * @param {DefaultApiWebGetCustomFieldAssociationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetCustomFieldAssociations(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetCustomFieldAssociations(requestParameters.organizationId, requestParameters.linkedEntityType, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of custom field definitions for the given organization including custom field associations
     * @param {DefaultApiWebGetCustomFieldDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetCustomFieldDefinitions(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetCustomFieldDefinitions(requestParameters.organizationId, requestParameters.dataType, requestParameters.name, requestParameters.limit, requestParameters.skip, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of field names catered soley to the web front-end
     * @param {DefaultApiWebGetFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetFields(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetFields(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of field names catered soley to the web front-end
     * @param {DefaultApiWebGetFieldsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetFieldsCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetFieldsCount(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of pin type names catered soley to the web front-end
     * @param {DefaultApiWebGetPinTypeNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetPinTypeNames(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetPinTypeNames(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many assets exists in the organization
     * @param {DefaultApiWebGetReportBlockAssetCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetReportBlockAssetCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetReportBlockAssetCount(requestParameters.organizationId, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.decommissioned, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of assets catered soley to the report block dialog front-end
     * @param {DefaultApiWebGetReportBlockAssetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetReportBlockAssets(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetReportBlockAssets(requestParameters.organizationId, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.decommissioned, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Counts how many buildings exists in the organization
     * @param {DefaultApiWebGetReportBlockBuildingCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetReportBlockBuildingCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetReportBlockBuildingCount(requestParameters.organizationId, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.decommissioned, requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the list of buildings catered soley to the report block dialog front-end
     * @param {DefaultApiWebGetReportBlockBuildingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetReportBlockBuildings(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetReportBlockBuildings(requestParameters.organizationId, requestParameters.name, requestParameters.building, requestParameters.pinType, requestParameters.limit, requestParameters.skip, requestParameters.sort, requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of work orders for the given organization
     * @param {DefaultApiWebGetWorkOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    webGetWorkOrders(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).webGetWorkOrders(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.startDate, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of work orders for the given building
     * @param {DefaultApiWorkOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workOrdersGet(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workOrdersGet(requestParameters.buildingId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.startDate, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the list of work orders for the given building
     * @param {DefaultApiWorkOrdersGetByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workOrdersGetById(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workOrdersGetById(requestParameters.buildingId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get the count of work orders for the given organization
     * @param {DefaultApiWorkOrdersGetCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    workOrdersGetCount(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).workOrdersGetCount(requestParameters.organizationId, requestParameters.limit, requestParameters.skip, requestParameters.sortBy, requestParameters.startDate, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=api.js.map